import { useState, useEffect, useRef, useMemo } from "react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
  PieChart, Pie, Cell, Tooltip as MuiTooltip 
} from "recharts";
import { CheckinAutocomplete, LeaveTypeAutocomplete, Employeeautocomplete, CheckinAutocompleteDash } from "../../ui-components/global/Autocomplete";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getLeaveentryData, postData, requestMail, EmergencyNotificationGet, EmergencyNotificationPost } from "../../store/reducers/Formapireducer";
import { dashBoard_V2, dashBoardAtten, fetchApidata } from "../../store/reducers/LoginReducer";
import { DashcalpostData } from "../../store/reducers/Formapireducer";
import { useParams } from "react-router-dom";
import { leaveAppoval } from "../../store/reducers/Listviewapireducer";
import CryptoJS from "crypto-js";
import Datavisual1 from "./Calendar";
import { useNavigate } from "react-router-dom";
import AssignmentIcon from '@mui/icons-material/Assignment';
import { getConfig } from "../../config";
import { Box, Button, Chip, Dialog, DialogContent, DialogTitle, Grid, IconButton, Skeleton, Stack, Table, TableBody, TableCell, TableHead, TableRow, TableContainer, Typography, CircularProgress } from "@mui/material";
import toast from "react-hot-toast";
import EventCalender from "./EventCalendar";
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import Swal from "sweetalert2";
import PreviewIcon from "@mui/icons-material/Preview";
import PlayCircleOutlinedIcon from "@mui/icons-material/PlayCircleOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import SettingsVoiceIcon from '@mui/icons-material/SettingsVoice';
import store from "../..";
const CompId = sessionStorage.getItem("companyId");
const empID = sessionStorage.getItem("EmpId");
const KEY = CryptoJS.enc.Utf8.parse("1234567890123456");
const IV = CryptoJS.enc.Utf8.parse("1234567890123456");
const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
const is003Subscription = SubscriptionCode?.endsWith("003");
console.log(is003Subscription, "--is003Subscription");

const companyClassification = sessionStorage.getItem("companyClassification");
const MultipleChildren = sessionStorage.getItem("MultipleChildren");
const EmpMailID = sessionStorage.getItem("EmpMailID");
const EmpMobileNo = sessionStorage.getItem("EmpMobileNo");
const ParentID = sessionStorage.getItem("ParentID");
console.log(MultipleChildren, EmpMailID, EmpMobileNo, ParentID, "--MultipleChildren in sessionstorage");

/* ─────────── HELPERS ─────────── */
const padZ = n => String(n).padStart(2, '0');
const fmtDate = d => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  return `${days[d.getDay()]}, ${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
};

/* ─────────── MINI COMPONENTS ─────────── */
function Toast({ toasts }) {
  return (
    <div style={{ position: 'fixed', bottom: 28, right: 28, zIndex: 9999, display: 'flex', flexDirection: 'column', gap: 8 }}>
      {toasts.map(t => (
        <div key={t.id} style={{ background: t.color, color: '#fff', padding: '12px 20px', borderRadius: 10, fontSize: 12, fontWeight: 700, boxShadow: '0 4px 20px rgba(0,0,0,0.2)', animation: 'fadeUp .25s ease' }}>
          ✓&nbsp;&nbsp;{t.msg}
        </div>
      ))}
    </div>
  );
}

function DonutChart({ data, colors, size = 120, cutout = 72, centerText, centerSub }) {
  const total = data.reduce((a, b) => a + b, 0);
  const chartData = total === 0 ? [{ value: 1 }] : data.map((v, i) => ({ value: v, color: colors[i] }));
  const completedColor = "#059669";
  const toDoColor = "#1d4ed8";
  const backLogColor = "#dc2626";
  const approvedColor = "#7c3aed";
  const blockedColor = "#d97706";
  const rejectedColor = "#94a3b8";
  const transferredColor = "#0e7490";

  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <PieChart width={size} height={size}>
        <Pie data={chartData} innerRadius={size * cutout / 200} outerRadius={size / 2 - 4} dataKey="value" strokeWidth={3} stroke="#fff">
          {chartData.map((entry, i) => (
            <Cell key={i} fill={total === 0 ? '#f1f5f9' : (entry.color || colors[i])} />
          ))}
        </Pie>
      </PieChart>
      {centerText && (
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', textAlign: 'center', pointerEvents: 'none' }}>
          <div style={{ fontFamily: "'Outfit',sans-serif", fontSize: size === 90 ? 14 : 20, fontWeight: 800, color: '#1e293b', lineHeight: 1 }}>{centerText}</div>
          {centerSub && <div style={{ fontSize: size === 90 ? 8 : 9, color: '#94a3b8', fontWeight: 600, marginTop: 2 }}>{centerSub}</div>}
        </div>
      )}
    </div>
  );
}

function Badge({ status, color }) {

  const completedColor = color?.completed;
  const toDoColor = color?.toDo;
  const backLogColor = color?.backLog;
  const approvedColor = color?.approved;
  const blockedColor = color?.blocked;
  const rejectedColor = color?.rejected;
  const transferredColor = color?.transferred;
  const styles = {
    todo: { bg: '#e0f9ff', color: toDoColor },
    completed: { bg: '#d1fae5', color: completedColor },
    backlog: { bg: '#ffe4e6', color: backLogColor },
    approved: { bg: '#ede9fe', color: approvedColor },
    inprogress: { bg: '#fef3c7', color: '#92400e' },
  };
  const s = styles[status] || { bg: '#f1f5f9', color: '#475569' };
  return <span style={{ display: 'inline-block', fontSize: 9, padding: '2px 8px', borderRadius: 20, fontWeight: 700, letterSpacing: 0.3, background: s.bg, color: s.color }}>{status ? status.charAt(0).toUpperCase() + status.slice(1) : ''}</span>;
}

/* ✅ DRILL-DOWN MODAL COMPONENT */
function DrillDownModal({ drill, tasks, onClose, t, colors }) {
  const completedColor = colors?.completed;
  const toDoColor = colors?.toDo;
  const backLogColor = colors?.backLog;
  const approvedColor = colors?.approved;
  const blockedColor = colors?.blocked;
  const rejectedColor = colors?.rejected;
  const transferredColor = colors?.transferred;

  if (!drill) return null;

  const taskTypeMap = {
    backlog: "Backlog",
    todo: "To Do",
    completed: "Completed",
    approved: "Approved",
    inprogress: "To Do",
    rejected: "Rejected",
    transferto: "Transferred To",
    blocked: "Blocked",
    totaltask: "Total Tasks"
  };

  const colorMap = {
    backlog: backLogColor,
    todo: toDoColor,
    completed: completedColor,
    approved: approvedColor,
    inprogress: toDoColor,
    rejected: rejectedColor,
    transferto: transferredColor,
    blocked: blockedColor,
    totaltask: approvedColor
  };

  const getColor = () => {
    const color = colorMap[drill.type];
    return color || t.accent || '#06b6d4';
  };

  const drillTasks = tasks || [];
  console.log(tasks, "--find tasks");

  const displayColor = getColor();

  const hexToRgb = (hex) => {
    if (!hex || hex.length < 7) return '100,100,100';
    try {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return `${r},${g},${b}`;
    } catch (e) {
      return '100,100,100';
    }
  };

  const rgb = hexToRgb(displayColor);

  return (
    <div onClick={e => { if (e.target === e.currentTarget) onClose(); }} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.7)', zIndex: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)' }}>
      <div style={{ background: '#fff', borderRadius: 16, width: 1000, maxWidth: '95vw', maxHeight: '85vh', boxShadow: '0 24px 64px rgba(0,0,0,0.25)', animation: 'modalIn .22s ease', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px 16px', borderBottom: '1px solid rgba(0,0,0,0.07)', background: `linear-gradient(135deg, rgba(${rgb}, 0.08) 0%, transparent 100%)` }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 40, height: 40, borderRadius: 10, background: displayColor, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: 18 }}>
              {drillTasks.length}
            </div>
            <div>
              <div style={{ fontFamily: "'Outfit',sans-serif", fontSize: 16, fontWeight: 700, color: '#1e293b' }}>
                {taskTypeMap[drill.type] || 'Tasks'}
              </div>
              {drill.source === "tillDate" ? (
                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
                  View: All Tasks
                </div>
              ) :
                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
                  View: {drill.view?.toUpperCase() || 'N/A'}
                </div>}
            </div>
          </div>
          <button onClick={onClose} style={{ width: 32, height: 32, borderRadius: '50%', background: '#f1f5f9', border: 'none', cursor: 'pointer', color: '#64748b', fontSize: 18, fontWeight: 600, transition: 'all .18s' }} onMouseEnter={e => e.currentTarget.style.background = '#e2e8f0'} onMouseLeave={e => e.currentTarget.style.background = '#f1f5f9'}>✕</button>
        </div>

        {/* Table Container */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '0' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f8fafc', zIndex: 10 }}>
              {/* <tr>
                {["#", "Tasks", "Project", "Type", "Sprint", "Status"].map((h) => (
                  <th key={h} style={{ fontSize: 10, letterSpacing: 0.8, color: '#94a3b8', fontWeight: 700, padding: '12px 10px', textAlign: 'left', background: '#f8fafc', borderBottom: '1px solid rgba(0,0,0,0.07)', minWidth: h === "Task Name" ? '200px' : 'auto' }}>{h}</th>
                ))}
              </tr> */}
              <tr>
                {["#", "Tasks", "Project", "Type", "Sprint"]
                  .concat(taskTypeMap[drill.type] === "Total Tasks" ? ["Status"] : [])
                  .map((h) => (
                    <th
                      key={h}
                      style={{
                        fontSize: 10,
                        letterSpacing: 0.8,
                        color: "#94a3b8",
                        fontWeight: 700,
                        padding: "12px 10px",
                        textAlign: "left",
                        background: "#f8fafc",
                        borderBottom: "1px solid rgba(0,0,0,0.07)",
                      }}
                    >
                      {h}
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {drillTasks.map((task, i) => (
                <tr key={task.id || i} style={{ borderBottom: '1px solid rgba(0,0,0,0.05)', transition: 'background .15s' }} onMouseEnter={(e) => (e.currentTarget.style.background = "#f8fafc")} onMouseLeave={(e) => (e.currentTarget.style.background = "")}>
                  <td style={{ padding: '10px 10px', fontSize: 11, color: '#64748b', fontWeight: 600, width: '40px' }}>{String(i + 1).padStart(2, "0")}</td>
                  <td style={{ padding: '10px 10px', fontSize: 12, color: '#1e293b', fontWeight: 500 }}>
                    <span style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={task.desc}>{task.name}</span>
                  </td>
                  <td style={{ padding: '10px 10px', fontSize: 11 }}>
                    {/* <span style={{ fontSize: 10, background: '#f1f5f9', padding: '3px 8px', borderRadius: 5, color: '#475569', fontWeight: 700, display: 'inline-block' }}>{task.project || '—'}</span> */}
                    <span style={{ fontSize: 10, background: '#f1f5f9', padding: '3px 8px', borderRadius: 5, color: '#475569', fontWeight: 700, display: 'inline-block' }}>{task.projectName || '—'}</span>
                  </td>
                  <td style={{ padding: '10px 10px', fontSize: 11 }}>
                    <span style={{ fontSize: 10, background: '#e0f2fe', padding: '3px 8px', borderRadius: 5, color: toDoColor, fontWeight: 600, display: 'inline-block' }}>{task.type || '—'}</span>
                  </td>
                  <td style={{ padding: '10px 10px', fontSize: 11, color: '#64748b' }}>
                    <span style={{ fontSize: 10, fontWeight: 600 }}>{task.sprint || 'N/A'}</span>
                  </td>
                  {/* <td style={{ padding: '10px 10px', fontSize: 11, color: '#1e293b', fontWeight: 500 }}>
                    {task.by || task.assignee || task.assignedTo || '—'}
                  </td> */}
                  {taskTypeMap[drill.type] === "Total Tasks" && (
                    <td style={{ padding: '10px 10px', fontSize: 11 }}>
                      <Badge status={task.status} color={colors} />
                    </td>
                  )}
                </tr>
              ))}
              {drillTasks.length === 0 && (
                <tr>
                  <td colSpan={7} style={{ textAlign: 'center', padding: 32, color: '#94a3b8', fontSize: 13 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
                      <svg width="40" height="40" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" style={{ opacity: 0.3 }}><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" /></svg>
                      No tasks found.
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 24px', borderTop: '1px solid rgba(0,0,0,0.07)', background: '#f8fafc' }}>
          <div style={{ fontSize: 11, color: '#64748b', fontWeight: 600 }}>
            Showing {drillTasks.length} {drillTasks.length === 1 ? 'task' : 'tasks'}
          </div>
          <button onClick={onClose} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid rgba(0,0,0,0.1)', background: '#fff', color: '#64748b', cursor: 'pointer', fontSize: 12, fontWeight: 600, transition: 'all .18s' }} onMouseEnter={e => { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.borderColor = t.accent; }} onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = 'rgba(0,0,0,0.1)'; }}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

/* ─────────── MODALS ─────────── */
function CheckInModal({ onClose, onSave, theme }) {
  const now = new Date();
  const [comment, setComment] = useState('');
  const [location, setLocation] = useState(null);
  const [gate, setGate] = useState(null);
  const [type, setType] = useState('Regular');
  const [err, setErr] = useState(false);
  const pad = (n) => n.toString().padStart(2, "0");
  const apiDate = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  const displayDate = `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${now.getFullYear()}`;
  const timeStr = `${pad(now.getHours())}:${pad(now.getMinutes())}`;
  const CompId = sessionStorage.getItem("companyId");
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const handle = () => {
    if (!comment.trim()) {
      setErr(true);
      return;
    }

    const payload = {
      RecordID: -1,
      CheckInType: "R",
      CheckInDate: apiDate,
      CheckInComment: comment,
      EmployeeID: sessionStorage.getItem("EmpId"),
      WorkAtHome: location?.Name === "Wfh" ? "Y" : "N",
      LocationRecID: location?.RecordID || 0,
      LocationName: location?.Name || "",
      GateRecID: gate?.RecordID || 0,
      GateName: gate?.Name || "",
      CheckInTime: timeStr,
      Source: "Cloud",
    };

    onSave(payload);
  };
  return (
    <ModalOverlay onClose={onClose}>
      <div style={{ background: '#fff', borderRadius: 18, width: 540, maxWidth: '95vw', boxShadow: '0 24px 64px rgba(0,0,0,0.25)', animation: 'modalIn .22s ease', overflow: 'hidden' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px 16px', borderBottom: '1px solid rgba(0,0,0,0.07)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: 'linear-gradient(135deg,#10b981,#059669)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="16" height="16" fill="none" stroke="#fff" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" /><polyline points="10 17 15 12 10 7" /><line x1="15" y1="12" x2="3" y2="12" /></svg>
            </div>
            <div>
              <div style={{ fontFamily: "'Outfit',sans-serif", fontSize: 15, fontWeight: 700 }}>Check In (New)</div>
              <div style={{ fontSize: 11, color: '#64748b', marginTop: 1 }}>Record your attendance check-in</div>
            </div>
          </div>
          <button onClick={onClose} style={{ width: 30, height: 30, borderRadius: '50%', background: '#f1f5f9', border: 'none', cursor: 'pointer', color: '#64748b', fontSize: 14 }}>✕</button>
        </div>
        <div style={{ padding: '20px 24px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
            <ModalField label="Location *">
              <CheckinAutocomplete
                value={location}
                onChange={(newValue) => {
                  setLocation(newValue);
                  setGate(null);
                }}
                url={`${listViewurl}?data={"Query":{"AccessID":"2051","ScreenName":"Location","Filter":"parentID=${CompId}","Any":""}}`}
              />
            </ModalField>
            <ModalField label="Gate *">
              <CheckinAutocomplete
                value={gate}
                onChange={(newValue) => setGate(newValue)}
                url={`${listViewurl}?data={"Query":{"AccessID":"2050","ScreenName":"Gate","Filter":"parentID=${location?.RecordID || 0}","Any":""}}`}
              />
            </ModalField>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
            <ModalField label="Check In Date">
              <input value={displayDate} readOnly style={inputStyle({ readonly: true })} />
            </ModalField>
            <ModalField label="Check In Time">
              <input value={timeStr} readOnly style={inputStyle({ readonly: true })} />
            </ModalField>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
            <ModalField label="Type">
              <SelectInput value={type} onChange={setType} options={['Regular']} />
            </ModalField>
            <ModalField label="Check In Comment *">
              <input value={comment} onChange={(e) => setComment(e.target.value)} placeholder="e.g. WFH – stable internet" style={inputStyle({})} />
            </ModalField>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 10, padding: '14px 24px 20px', borderTop: '1px solid rgba(0,0,0,0.07)' }}>
          <button onClick={onClose} style={cancelBtnStyle}>Cancel</button>
          <button onClick={handle} style={{ ...saveBtnStyle, background: 'linear-gradient(135deg,#10b981,#059669)' }}>
            <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" style={{ marginRight: 5 }}><path d="M5 13l4 4L19 7" /></svg>Save Check In
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
}

function CheckOutModal({ onClose, onSave, checkedInID }) {
  const now = new Date();
  const [comment, setComment] = useState('');
  const [location, setLocation] = useState(null);
  const [gate, setGate] = useState(null);
  const [type, setType] = useState('Regular');
  const pad = (n) => n.toString().padStart(2, "0");
  const apiDate = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  const displayDate = `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${now.getFullYear()}`;
  const timeStr = `${pad(now.getHours())}:${pad(now.getMinutes())}`;
  const CompId = sessionStorage.getItem("companyId");
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);

  const handle = () => {
    if (!comment.trim()) return;

    const payload = {
      RecordID: checkedInID,
      CheckOutType: "R",
      CheckOutDate: apiDate,
      CheckOutComment: comment,
      EmployeeID: sessionStorage.getItem("EmpId"),
      LocationRecID: location?.RecordID || 0,
      LocationName: location?.Name || "",
      GateRecID: gate?.RecordID || 0,
      GateName: gate?.Name || "",
      CheckOutTime: timeStr,
      LatestCheckinDate: '0',
      Source: "Cloud",
    };

    onSave(payload);
  };
  return (
    <ModalOverlay onClose={onClose}>
      <div style={{ background: '#fff', borderRadius: 18, width: 540, maxWidth: '95vw', boxShadow: '0 24px 64px rgba(0,0,0,0.25)', animation: 'modalIn .22s ease', overflow: 'hidden' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px 16px', borderBottom: '1px solid rgba(0,0,0,0.07)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: 'linear-gradient(135deg,#f97316,#ea580c)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="16" height="16" fill="none" stroke="#fff" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></svg>
            </div>
            <div>
              <div style={{ fontFamily: "'Outfit',sans-serif", fontSize: 15, fontWeight: 700 }}>Check Out</div>
              <div style={{ fontSize: 11, color: '#64748b', marginTop: 1 }}>Record your attendance check-out</div>
            </div>
          </div>
          <button onClick={onClose} style={{ width: 30, height: 30, borderRadius: '50%', background: '#f1f5f9', border: 'none', cursor: 'pointer', color: '#64748b', fontSize: 14 }}>✕</button>
        </div>
        <div style={{ padding: '20px 24px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
            <ModalField label="Location *">
              <CheckinAutocomplete
                value={location}
                onChange={(newValue) => {
                  setLocation(newValue);
                  setGate(null);
                }}
                url={`${listViewurl}?data={"Query":{"AccessID":"2051","ScreenName":"Location","Filter":"parentID=${CompId}","Any":""}}`}
              />
            </ModalField>
            <ModalField label="Gate *">
              <CheckinAutocomplete
                value={gate}
                onChange={(newValue) => setGate(newValue)}
                url={`${listViewurl}?data={"Query":{"AccessID":"2050","ScreenName":"Gate","Filter":"parentID=${location?.RecordID || 0}","Any":""}}`}
              />
            </ModalField>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
            <ModalField label="Check Out Date">
              <input value={displayDate} readOnly style={inputStyle({ readonly: true })} />
            </ModalField>
            <ModalField label="Check Out Time">
              <input value={timeStr} readOnly style={inputStyle({ readonly: true })} />
            </ModalField>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
            <ModalField label="Type">
              <SelectInput value={type} onChange={setType} options={['Regular']} />
            </ModalField>
            <ModalField label="Check Out Comment *">
              <input value={comment} onChange={(e) => setComment(e.target.value)} placeholder="e.g. All tasks completed" style={inputStyle({})} />
            </ModalField>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 10, padding: '14px 24px 20px', borderTop: '1px solid rgba(0,0,0,0.07)' }}>
          <button onClick={onClose} style={cancelBtnStyle}>Cancel</button>
          <button onClick={handle} style={{ ...saveBtnStyle, background: 'linear-gradient(135deg,#f97316,#ea580c)' }}>
            <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" style={{ marginRight: 5 }}><path d="M5 13l4 4L19 7" /></svg>Save Check Out
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
}

function ApplyLeaveModal({ onClose, onSave, colors, balances }) {
  const [leaveType, setLeaveType] = useState(null);
  const [leavepart, setLeavepart] = useState(null);
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [reason, setReason] = useState('');
  const [selectedLeavetypebalance, setSelectedLeavetypebalance] = useState("");
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();
  const CompId = sessionStorage.getItem("companyId");
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const completedColor = colors?.completed;
  const toDoColor = colors?.toDo;
  const backLogColor = colors?.backLog;
  const approvedColor = colors?.approved;
  const blockedColor = colors?.blocked;
  const rejectedColor = colors?.rejected;
  const transferredColor = colors?.transferred;
  const balance = balances || [];
  console.log("🚀 ~ ApplyLeaveModal ~ balance:", balance)
  const Balancedayfind = async (LeaveTypeID) => {
    try {
      const response = await dispatch(
        getLeaveentryData({
          EmployeeID: sessionStorage.getItem("EmpId"),
          LeaveTypeID: LeaveTypeID,
          Year: currentYear,
        }),
      );
      setSelectedLeavetypebalance(response.payload.Data.ELC_ELIGIBLEDAYS);
    } catch (error) {
      console.error("Error in Balancedayfind:", error);
    }
  };

  // const leaveBalances = {
  //   'Casual Leave': { bal: 12 },
  //   'Medical Leave': { bal: 9 },
  //   'Sick Leave': { bal: 12 }
  // };

  const lbcStyle = (type) => {
    const isActive = leaveType === type;
    const map = {
      'Casual Leave': {
        bg: isActive ? '#dcfce7' : '#f0fdf4',
        border: isActive ? completedColor : '#bbf7d0',
        numColor: completedColor
      },
      'Medical Leave': {
        bg: isActive ? '#dbeafe' : '#eff6ff',
        border: isActive ? approvedColor : '#bfdbfe',
        numColor: approvedColor
      },
      'Sick Leave': {
        bg: isActive ? '#fef3c7' : '#fffbeb',
        border: isActive ? blockedColor : '#fde68a',
        numColor: blockedColor
      }
    };
    return map[type];
  };

  const handle = () => {
    if (!reason.trim()) return;

    const payload = {
      RecordID: -1,
      FromDate: from,
      ToDate: to,
      LeavePart:
        leavepart === "First Half"
          ? "FH"
          : leavepart === "Second Half"
            ? "SH"
            : leavepart === "Full Day"
              ? "N"
              : "",
      Comments: reason,
      ManagerComments: "",
      EmployeeID: sessionStorage.getItem("EmpId"),
      Status: "AL",
      AppliedDate: new Date().toISOString().split("T")[0],
      SortOrder: "1",
      Disable: "N",
      Source: "Self",
      LeaveTypeID: leaveType?.RecordID || 0,
      LeaveTypeName: leaveType?.Name || "",
      BalanceDay: selectedLeavetypebalance || 0,
      ApprovedBy: sessionStorage.getItem("EmpId"),
    };

    onSave(payload);
  };

  return (
    <ModalOverlay onClose={onClose}>
      <div style={{ background: '#fff', borderRadius: 20, width: 500, maxWidth: '95vw', boxShadow: '0 24px 64px rgba(0,0,0,0.2)', animation: 'modalIn .22s ease', overflow: 'hidden' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px 24px 16px', borderBottom: '1px solid rgba(0,0,0,0.07)' }}>
          <div style={{ fontSize: 17, fontWeight: 700 }}>Apply for Leave</div>
          <button onClick={onClose} style={{ border: 'none', background: '#f1f5f9', borderRadius: '50%', width: 30, height: 30 }}>✕</button>
        </div>

        <div style={{ padding: '16px 24px' }}>
          {/* <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 20 }}>
            {Object.keys(leaveBalances).map((k) => {
              const s = lbcStyle(k);
              return (
                <div
                  key={k}
                  onClick={() => setLeaveType(k)}
                  style={{
                    borderRadius: 12,
                    padding: 14,
                    textAlign: 'center',
                    cursor: 'pointer',
                    border: `2px solid ${s.border}`,
                    background: s.bg
                  }}
                >
                  <div style={{ fontSize: 11, fontWeight: 700 }}>{k}</div>
                  <div style={{ fontSize: 26, fontWeight: 800, color: s.numColor }}>
                    {leaveBalances[k].bal}
                  </div>
                  <div style={{ fontSize: 10 }}>days left</div>
                </div>
              );
            })}
          </div> */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 20 }}>
            {balance?.map((item, index) => {
              const cleanLabel = (str) => str?.trim();

              const isActive = leaveType === cleanLabel(item.label);
              return (
                <div
                  key={index}
                  onClick={() => {
                    setLeaveType(cleanLabel(item.label));
                    setSelectedLeavetypebalance(item.rValue);
                  }}
                  style={{
                    borderRadius: 12,
                    padding: 14,
                    textAlign: 'center',
                    cursor: 'pointer',
                    border: `2px solid ${isActive ? completedColor : '#e5e7eb'}`,
                    background: isActive ? '#f0fdf4' : '#fff'
                  }}
                >
                  {/* LABEL */}
                  <div style={{ fontSize: 11, fontWeight: 700 }}>
                    {cleanLabel(item.label)}
                  </div>

                  {/* BALANCE */}
                  <div style={{ fontSize: 26, fontWeight: 800, color: completedColor }}>
                    {item.rValue}
                  </div>

                  <div style={{ fontSize: 10 }}>days left</div>
                </div>
              );
            })}
          </div>
          <div style={{ marginBottom: 14 }}>
            <ModalField label="Leave Type *">
              <LeaveTypeAutocomplete
                value={leaveType}
                onChange={async (val) => {
                  setLeaveType(val)
                  if (val?.RecordID) {
                    await Balancedayfind(val?.RecordID);
                  }
                }}
                url={`${listViewurl}?data={"Query":{"AccessID":"2107","ScreenName":"Leave Type","Filter":"parentID=${CompId} AND EmployeeID='${sessionStorage.getItem("EmpId")}' AND Year='2026'","Any":""}}`}
              />
            </ModalField>
          </div>

          <div style={{ marginBottom: 14 }}>
            <ModalField label="Leave Part *">
              <SelectInput
                value={leavepart}
                onChange={setLeavepart}
                options={["First Half", "Second Half", "Full Day"]}
              />
            </ModalField>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
            <ModalField label="From Date *">
              <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} style={inputStyle({})} />
            </ModalField>

            <ModalField label="To Date *">
              <input type="date" value={to} onChange={(e) => setTo(e.target.value)} style={inputStyle({})} />
            </ModalField>
          </div>

          <div style={{ marginBottom: 14 }}>
            <ModalField label="Reason *">
              <textarea
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value);
                }}
                style={{
                  ...inputStyle({}),
                  minHeight: 90
                }}
              />
            </ModalField>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, padding: '14px 24px 20px', borderTop: '1px solid rgba(0,0,0,0.07)' }}>
          <button onClick={onClose} style={cancelBtnStyle}>Cancel</button>
          <button onClick={handle} style={{
            ...saveBtnStyle,
            // background: 'linear-gradient(135deg,#3b82f6,#4f46e5)',
            background: toDoColor,
            flex: 1, justifyContent: 'center'
          }}>Submit Application →</button>
        </div>
      </div>
    </ModalOverlay>
  );
}

function ModalOverlay({ children, onClose }) {
  return (
    <div onClick={e => { if (e.target === e.currentTarget) onClose(); }} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.7)', zIndex: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)' }}>
      {children}
    </div>
  );
}

function ModalField({ label, children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      <label style={{ fontSize: 10, fontWeight: 700, letterSpacing: 0.5, color: '#64748b' }}>{label}</label>
      {children}
    </div>
  );
}

function SelectInput({ value, onChange, options }) {
  return (
    <div style={{ position: 'relative' }}>
      <select value={value || ''} onChange={e => onChange(e.target.value)} style={{ ...inputStyle({}), appearance: 'none', width: '100%', cursor: 'pointer' }}>
        <option value="">-- Select --</option>
        {options.map(o => <option key={o}>{o}</option>)}
      </select>
      <span style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', color: '#94a3b8', fontSize: 11 }}>▾</span>
    </div>
  );
}

const inputStyle = ({ err, readonly } = {}) => ({
  width: '100%', padding: '9px 12px', border: `1.5px solid ${err ? '#f43f5e' : 'rgba(0,0,0,0.1)'}`, borderRadius: 9,
  fontFamily: "'Plus Jakarta Sans',sans-serif", fontSize: 13, color: readonly ? '#64748b' : '#1e293b',
  background: readonly ? '#f8fafc' : '#fff', outline: 'none', boxSizing: 'border-box',
});

const cancelBtnStyle = { padding: '9px 22px', borderRadius: 9, fontFamily: "'Plus Jakarta Sans',sans-serif", fontSize: 12, fontWeight: 700, cursor: 'pointer', border: 'none', background: '#f1f5f9', color: '#64748b' };
const saveBtnStyle = { padding: '9px 22px', borderRadius: 9, fontFamily: "'Plus Jakarta Sans',sans-serif", fontSize: 12, fontWeight: 700, cursor: 'pointer', border: 'none', color: '#fff', display: 'flex', alignItems: 'center' };

/* ─────────── THEMES ─────────── */
const themes = {
  default: { accent: '#06b6d4', accent2: '#6366f1', sidebar: '#0f172a', bg: '#f4f6fb', dot: '#06b6d4' },
  ocean: { accent: '#0ea5e9', accent2: '#6366f1', sidebar: '#0c1a2e', bg: '#eef6fb', dot: '#0ea5e9' },
  violet: { accent: '#8b5cf6', accent2: '#ec4899', sidebar: '#1a0f2e', bg: '#f3f0fb', dot: '#8b5cf6' },
  rose: { accent: '#f43f5e', accent2: '#fb923c', sidebar: '#2a0f16', bg: '#fdf2f4', dot: '#f43f5e' },
  emerald: { accent: '#10b981', accent2: '#06b6d4', sidebar: '#0a1f16', bg: '#f0faf5', dot: '#10b981' },
  slate: { accent: '#475569', accent2: '#64748b', sidebar: '#1e293b', bg: '#f1f5f9', dot: '#475569' },
};

export function encryptDataUrlSafe(plainText) {
  const encrypted = CryptoJS.AES.encrypt(plainText, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
  return encrypted.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

/* ─────────── MAIN APP ─────────── */
export default function EmployeeDashboard() {
  const [theme, setTheme] = useState('default');
  const [themeOpen, setThemeOpen] = useState(false);
  const [clock, setClock] = useState(new Date());
  const [modal, setModal] = useState(null);
  const [toasts, setToasts] = useState([]);
  const [wtdView, setWtdView] = useState('w2d');

  const [ytdView, setYtdView] = useState('Y2D');
  const [drill, setDrill] = useState(null);
  const [drillModal, setDrillModal] = useState(null);
  const [isCalendar, setIsCalendar] = useState(false);
  const [isEventCalendar, setIsEventCalendar] = useState(false);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [leaveBalances, setLeaveBalances] = useState([]);
  console.log("🚀 ~ EmployeeDashboard ~ leaveBalances:", leaveBalances)
  const themeRef = useRef(null);
  const t = themes[theme];
  const navigate = useNavigate();

  const empID = sessionStorage.getItem("EmpId");
  const EmpName = sessionStorage.getItem("EmpName");
  const currentYear = new Date().getFullYear();
  const compID = sessionStorage.getItem("companyId");
  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode?.endsWith("003");
  console.log("🚀 ~ EmployeeDashboard ~ is003Subscription:", is003Subscription)
  const MultipleChildren = sessionStorage.getItem("MultipleChildren");
  const EmpMailID = sessionStorage.getItem("EmpMailID");
  const EmpMobileNo = sessionStorage.getItem("EmpMobileNo");
  const ParentID = sessionStorage.getItem("ParentID");
  console.log(MultipleChildren, EmpMailID, EmpMobileNo, ParentID, "--MultipleChildren in sessionstorage");

  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const dashboardDataV2 = useSelector((state) => state.loginApi.dashboardDataV2);
  const dashboardDataV2Loading = useSelector((state) => state.loginApi.loadingV2);
  const emergencyData = useSelector((state) => state.formApi.EventNotificationData);
  console.log("🚀 ~ EmployeeDashboard ~ emergencyData:", emergencyData)
  const emergencyDataLoading = useSelector((state) => state.formApi.EventNotificationloading);
  const data = dashboardDataV2 || {};
  const taskSummary = data?.taskSummaryCardData || [];
  const overallColors = data?.Colours || [];
  const taskTimeline = data?.taskTimeline || {};
  const projectStats = data?.projectStats || [];
  const taskAging = data?.taskAging || {};
  const attendance = data?.attendance || {};
  const leaveDetailsData = data?.leaveDetailsData || {};
  const tasks = data?.tasks || {};
  const tillDateTasks = data?.tillDateTasks || {};
  const Classification = sessionStorage.getItem("Classification");
  const isStaff = Classification === "Teaching Staff" || "Staff";
  const completedColor = overallColors?.completed;
  const toDoColor = overallColors?.toDo;
  const backLogColor = overallColors?.backLog;
  const approvedColor = overallColors?.approved;
  const blockedColor = overallColors?.blocked;
  const rejectedColor = overallColors?.rejected;
  const transferredColor = overallColors?.transferred;
  const totalTaskColor = overallColors?.totalTask;

  const [agingView, setAgingView] = useState('completed');
  const [agingColor, setAgingColor] = useState(completedColor);;
  const [agingLabel, setAgingLabel] = useState('Completed');


  const [showAudioPlayer, setShowAudioPlayer] = useState(false);
const [audioSrc, setAudioSrc] = useState("");
  const [notificationOpen, setNotificationOpen] =
    useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [notifications, setNotifications] =
    useState([
      {
        RecordID: 1,
        Title: "Cyclone Alert",
        Message:
          "Heavy rain expected tomorrow",
        IsRead: false
      },
      {
        RecordID: 2,
        Title: "Server Maintenance",
        Message:
          "Dashboard unavailable 10PM",
        IsRead: false
      }
    ]);
  const CheckInOutDetails = data?.attendance?.CheckInOutDetails || {};
  const isManager = sessionStorage.getItem("isManager");
  const isScrumaster = sessionStorage.getItem("isScrumaster");
  const isprojectmanager = sessionStorage.getItem("isprojectmanager");
  const qualityassurance = sessionStorage.getItem("qualityassurance");
  // console.log(isManager, isScrumaster, isprojectmanager, qualityassurance, "Dashboardddddd");
  // console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");
  // const drillTasks = drillModal ? tasks?.[drillModal.view || "w2d"]?.[drillModal.type] || [] : [];
  const drillTasks = drillModal
    ? drillModal.source === "tillDate"
      ? tillDateTasks?.[drillModal.type] || []
      : tasks?.[drillModal.view || "w2d"]?.[drillModal.type] || []
    : [];
  const dispatch = useDispatch();
  const params = useParams();

  const today = new Date().toISOString().split("T")[0];
  useEffect(() => {
    dispatch(dashBoard_V2({ data: { EmployeeID: empID, Type: params.Type, CompanyID: compID } }));
  }, [dispatch, empID, params]);
  useEffect(() => {
    dispatch(EmergencyNotificationGet({ EmployeeID: empID, CompanyID: compID, EventDate: today }));
  }, [dispatch, empID, compID, today]);

  useEffect(() => {
    const id = setInterval(() => setClock(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const handler = (e) => { if (themeRef.current && !themeRef.current.contains(e.target)) setThemeOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') { setModal(null); setDrillModal(null); } };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, []);

  const showToast = (msg, color) => {
    const id = Date.now();
    setToasts(p => [...p, { id, msg, color }]);
    setTimeout(() => setToasts(p => p.filter(t => t.id !== id)), 3000);
  };

  const onCheckIn = async (data) => {
    try {
      const response = await dispatch(
        postData({ accessID: "TR123", action: "insert", idata: data })
      );
      const res = response.payload;
      if (res.Status === "Y") {
        showToast("Check-In Successful", "#10b981");
        dispatch(dashBoard_V2({ data: { EmployeeID: empID, Type: params.Type, CompanyID: compID } }));
        setModal(null);
      } else {
        showToast(res.Msg || res.Message || "Error occurred", "#ef4444");
      }
    } catch (err) {
      console.error(err);
      showToast("Something went wrong", "#ef4444");
    }
  };

  const onCheckOut = async (data) => {
    try {
      const response = await dispatch(
        postData({ accessID: "TR124", action: "update", idata: data })
      );
      const res = response.payload;
      if (res.Status === "Y") {
        showToast("Check-Out Successful", "#10b981");
        dispatch(dashBoard_V2({ data: { EmployeeID: empID, Type: params.Type } }));
        setModal(null);
      } else {
        showToast(res.Msg || res.Message || "Error occurred", "#ef4444");
      }
    } catch (err) {
      console.error(err);
      showToast("Something went wrong", "#ef4444");
    }
  };

  const onLeave = async (data) => {
    try {
      const response = await dispatch(
        postData({ accessID: "TR208", action: "insert", idata: data })
      );
      const res = response.payload;
      if (res.Status === "Y") {
        showToast("Leave Applied Successfully", "#10b981");
        setModal(null);
        dispatch(
          requestMail({
            EmployeeID: sessionStorage.getItem("EmpId"),
            Type: "L",
            RecordID: res.EleaveRecid,
            encryptData: encryptDataUrlSafe(res.EleaveRecid),
          })
        );
        dispatch(
          leaveAppoval({
            data: {
              RecordID: res.EleaveRecid,
              ManagerID: "",
              EmployeeID: sessionStorage.getItem("EmpId"),
              Type: "L",
              Status: "AL",
              Reason: "",
            },
          })
        );
      } else {
        showToast(res.Msg || res.Message || "Error occurred", "#ef4444");
      }
    } catch (err) {
      console.error(err);
      showToast("Something went wrong", "#ef4444");
    }
  };

  // const agingData = taskAging?.[agingView] || { data: [0], labels: [], colors: [] };
  const agingColorMap = {
    backlog: ['#f43f5e', '#fb923c', '#fcd34d'],   // red → orange → yellow
    todo: ['#06b6d4', '#3b82f6', '#8b5cf6'],   // cyan → blue → violet
    completed: ['#10b981', '#34d399', '#6ee7b7'], // dark green → mid → light
  };

  // const rawAgingData = taskAging?.[agingView] || { data: [0], labels: [], colors: [] };
  const rawAgingData = taskAging?.[agingView] || { data: [], labels: [], colors: [] };
  const fallbackColors = agingColorMap[agingView] || [];

  // const agingData = {
  //   ...rawAgingData,
  //   colors: agingColorMap[agingView] || rawAgingData.colors,
  // };
  const agingData = {
    ...rawAgingData,
    colors: rawAgingData.colors?.length
      ? rawAgingData.colors
      : [],
  };
  const agTotal = agingData.data.reduce((a, b) => a + b, 0);
  const agPct = agTotal === 0 ? '0%' : Math.round((agingData.data[0] / agTotal) * 100) + '%';

  const ytdData = attendance?.[ytdView] || { data: [0], labels: [], colors: [] };
  const ytdTotal = ytdData.data.reduce((a, b) => a + b, 0);
  const ytdPct = ytdTotal === 0 ? '0%' : Math.round((ytdData.data[0] / ytdTotal) * 100) + '%';

  // ✅ Calculate running time from check-in - LIVE TIMER
  const getElapsedTime = () => {
    if (CheckInOutDetails?.CheckStatus !== 'A' && CheckInOutDetails?.CheckStatus !== 'B') {
      return { hours: 0, minutes: 0, seconds: 0, display: '0h 0m' };
    }

    if (CheckInOutDetails?.CheckInTime) {
      try {
        const now = new Date();

        const timeStr = CheckInOutDetails.CheckInTime.trim();
        let checkHour, checkMin;

        if (timeStr.includes('AM') || timeStr.includes('PM')) {
          const timePart = timeStr.split(' ')[0];
          let [hour, min] = timePart.split(':').map(num => parseInt(num, 10));
          const isPM = timeStr.includes('PM');

          if (isPM && hour !== 12) {
            hour += 12;
          } else if (!isPM && hour === 12) {
            hour = 0;
          }

          checkHour = hour;
          checkMin = min;
        } else {
          [checkHour, checkMin] = timeStr.split(':').map(num => parseInt(num, 10));
        }

        let diffMs;

        if (CheckInOutDetails?.CheckStatus === 'B' && CheckInOutDetails?.CheckOutTime) {
          try {
            const outStr = CheckInOutDetails.CheckOutTime.trim();
            let checkOutHour, checkOutMin;

            if (outStr.includes('AM') || outStr.includes('PM')) {
              const outTimePart = outStr.split(' ')[0];
              let [outHour, outMin] = outTimePart.split(':').map(num => parseInt(num, 10));
              const isOutPM = outStr.includes('PM');

              if (isOutPM && outHour !== 12) {
                outHour += 12;
              } else if (!isOutPM && outHour === 12) {
                outHour = 0;
              }

              checkOutHour = outHour;
              checkOutMin = outMin;
            } else {
              [checkOutHour, checkOutMin] = outStr.split(':').map(num => parseInt(num, 10));
            }

            const checkInDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), checkHour, checkMin, 0);
            const checkOutDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), checkOutHour, checkOutMin, 0);

            diffMs = checkOutDate.getTime() - checkInDate.getTime();
          } catch (err) {
            console.error('Error parsing checkout time:', err);
            const checkInDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), checkHour, checkMin, 0);
            diffMs = now.getTime() - checkInDate.getTime();
          }
        } else {
          const checkInDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), checkHour, checkMin, 0);
          diffMs = now.getTime() - checkInDate.getTime();
        }

        const diffSeconds = Math.floor(diffMs / 1000);

        const hours = Math.floor(diffSeconds / 3600);
        const minutes = Math.floor((diffSeconds % 3600) / 60);

        return {
          hours: Math.max(0, hours),
          minutes: Math.max(0, minutes),
          display: `${String(Math.max(0, hours)).padStart(2, '0')}h ${String(Math.max(0, minutes)).padStart(2, '0')}m`
        };
      } catch (err) {
        console.error('Error calculating elapsed time:', err, CheckInOutDetails?.CheckInTime);
        return { hours: 0, minutes: 0, seconds: 0, display: '0h 0m' };
      }
    }

    return { hours: 0, minutes: 0, seconds: 0, display: '0h 0m' };
  };

  const elapsedTime = getElapsedTime();

  const getDashboardTitle = () => {
    if (companyClassification === "Board Of Directors") return "PRINCIPAL DASHBOARD";
    if (companyClassification === "Staff") return "STAFF DASHBOARD";
    if (companyClassification === "Intern") return "STUDENT DASHBOARD";
    if (isCalendar) return "TASK CALENDAR";
    if (isEventCalendar) return "EVENT CALENDAR";
    return "PERSONNEL DASHBOARD";
  };
  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour < 12) return "Good Morning";
    if (hour < 17) return "Good Afternoon";
    return "Good Evening";
  };

  const renderDashboardNavigation = () => {


    return (
      <>
        {is003Subscription && Classification === "Student" && (
          <button
            key={`nav-cal-${is003Subscription}-${isprojectmanager}`}
            onClick={() => {
              navigate("/Apps/Class-Timetable/TM");
              // dispatch(
              //   dashBoardAtten({ data: { EmployeeID: empID, Type: "T" } })
              // );
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: 10,
              border: '1px solid rgba(0,0,0,0.07)',
              background: t.bg,
              color: t.accent,
              cursor: 'pointer',
              transition: 'all .18s'
            }}
            title="Timetable"
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f1f5f9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = t.bg;
            }}
          >
            {/* Calendar Icon */}
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              <line x1="9" y1="12" x2="15" y2="12" />
              <line x1="9" y1="16" x2="15" y2="16" />
            </svg>
          </button>
        )}

        {/* Class Calendar: is003Subscription && isprojectmanager != Y */}
        {is003Subscription && isprojectmanager != "Y" && Classification !== "Student" && (
          <button
            key={`nav-cal-${is003Subscription}-${isprojectmanager}`}
            onClick={() => {
              navigate("/Apps/ClassCalendar-dashbord/C");
              dispatch(
                dashBoardAtten({ data: { EmployeeID: empID, Type: "T" } })
              );
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: 10,
              border: '1px solid rgba(0,0,0,0.07)',
              background: t.bg,
              color: t.accent,
              cursor: 'pointer',
              transition: 'all .18s'
            }}
            title="Class Calendar"
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f1f5f9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = t.bg;
            }}
          >
            {/* Calendar Icon */}
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              <line x1="9" y1="12" x2="15" y2="12" />
              <line x1="9" y1="16" x2="15" y2="16" />
            </svg>
          </button>
        )}
        {/* ✅ Teacher Occupancy: only visible when isStaff is true */}
        {isStaff && Classification !== "Student" && (
          <button
            key="nav-teacher-occupancy"
            onClick={() => navigate('/Apps/teacher-occupancy')}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: 10,
              border: '1px solid rgba(0,0,0,0.07)',
              background: t.bg,
              color: t.accent,
              cursor: 'pointer',
              transition: 'all .18s'
            }}
            title="Staff Timetable"
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f1f5f9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = t.bg;
            }}
          >
            {/* Teacher / Occupancy icon: person at a board */}
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <circle cx="12" cy="6" r="2.5" />
              <path d="M7 21v-2a5 5 0 0110 0v2" />
              <rect x="2" y="3" width="20" height="12" rx="2" />
              <line x1="2" y1="11" x2="22" y2="11" />
            </svg>
          </button>
        )}
        {/* Condition 1: isManager == 1 && isScrumaster == Y && isprojectmanager == Y → Project Manager */}
        {isManager == 1 && isScrumaster == "Y" && isprojectmanager == "Y" && (
          <button
            key={`nav-pm-${isScrumaster}-${isprojectmanager}`}
            onClick={() => {
              dispatch(
                dashBoardAtten({ data: { EmployeeID: empID, Type: "P" } })
              );
              navigate(-1);
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: 10,
              border: '1px solid rgba(0,0,0,0.07)',
              background: t.bg,
              color: t.accent,
              cursor: 'pointer',
              transition: 'all .18s'
            }}
            title="Project Manager Dashboard"
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f1f5f9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = t.bg;
            }}
          >
            {/* Assignment/Project Icon */}
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              <line x1="9" y1="12" x2="15" y2="12" />
              <line x1="9" y1="16" x2="15" y2="16" />
            </svg>
          </button>
        )}

        {/* Condition 2: isManager == 1 && isScrumaster == N && isprojectmanager == Y → Project Manager */}
        {isManager == 1 && isScrumaster != "Y" && isprojectmanager == "Y" && (
          <button
            key={`nav-pm2-${isScrumaster}-${isprojectmanager}`}
            onClick={() => {
              dispatch(
                dashBoardAtten({ data: { EmployeeID: empID, Type: "P" } })
              );
              navigate(-1);
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: 10,
              border: '1px solid rgba(0,0,0,0.07)',
              background: t.bg,
              color: t.accent,
              cursor: 'pointer',
              transition: 'all .18s'
            }}
            title="Project Manager Dashboard"
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f1f5f9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = t.bg;
            }}
          >
            {/* Assignment/Project Icon */}
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              <line x1="9" y1="12" x2="15" y2="12" />
              <line x1="9" y1="16" x2="15" y2="16" />
            </svg>
          </button>
        )}

        {/* Condition 4: isManager == 1 && qualityassurance == Y && isprojectmanager != Y → Project Manager */}
        {isManager == 1 && qualityassurance === "Y" && isprojectmanager != "Y" && (
          <button
            key={`nav-pm3-${qualityassurance}-${isprojectmanager}`}
            onClick={() => {
              dispatch(
                dashBoardAtten({ data: { EmployeeID: empID, Type: "P" } })
              );
              navigate(-1);
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: 10,
              border: '1px solid rgba(0,0,0,0.07)',
              background: t.bg,
              color: t.accent,
              cursor: 'pointer',
              transition: 'all .18s'
            }}
            title="Project Manager Dashboard"
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f1f5f9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = t.bg;
            }}
          >
            {/* Assignment/Project Icon */}
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              <line x1="9" y1="12" x2="15" y2="12" />
              <line x1="9" y1="16" x2="15" y2="16" />
            </svg>
          </button>
        )}

        {/* Condition 3: isManager == 1 && isScrumaster == N && isprojectmanager == N && qualityassurance == N → Manager */}
        {isManager == 1 && isScrumaster != "Y" && isprojectmanager != "Y" && qualityassurance != "Y" && (
          <button
            key={`nav-mgr-${isScrumaster}-${isprojectmanager}-${qualityassurance}`}
            onClick={() => {
              dispatch(
                dashBoardAtten({ data: { EmployeeID: empID, Type: "M" } })
              );
              navigate(-1);
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: 10,
              border: '1px solid rgba(0,0,0,0.07)',
              background: t.bg,
              color: t.accent,
              cursor: 'pointer',
              transition: 'all .18s'
            }}
            title="Manager Dashboard"
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f1f5f9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = t.bg;
            }}
          >
            {/* Supervised/Manager Icon */}
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <circle cx="9" cy="7" r="3" />
              <path d="M12 13c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" />
              <path d="M3 20c0-2.209 2.239-4 5-4s5 1.791 5 4" />
              <path d="M16 20c0-2.209 1.119-4 2.5-4S21 17.791 21 20" />
            </svg>
          </button>
        )}

        {/* Condition 5: isManager == 1 && isScrumaster == Y && isprojectmanager == N → Scrum Master */}
        {isManager == 1 && isScrumaster == "Y" && isprojectmanager != "Y" && (
          <button
            key={`nav-sm-${isScrumaster}-${isprojectmanager}`}
            onClick={() => {
              dispatch(
                dashBoardAtten({ data: { EmployeeID: empID, Type: "S" } })
              );
              navigate(-1);
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: 10,
              border: '1px solid rgba(0,0,0,0.07)',
              background: t.bg,
              color: t.accent,
              cursor: 'pointer',
              transition: 'all .18s'
            }}
            title="Scrum Master Dashboard"
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#f1f5f9';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = t.bg;
            }}
          >
            {/* Groups/Team Icon */}
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 00-3-3.87" />
              <path d="M16 3.13a4 4 0 010 7.75" />
            </svg>
          </button>
        )}


      </>
    );
  };

  // const handleEventPopUp = (notification) => {

  //   const notificationMessage = notification?.Message || "You have a new notification";
  //   Swal.fire({
  //     title: 'Emergency Notification',
  //     text: notificationMessage,
  //     icon: 'warning',
  //     confirmButtonText: 'Read',
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //   });
  // }

  const [refreshKey, setRefreshKey] = useState(0);
  const [childName, setChildName] = useState(null);

  const wtdChartData = useMemo(() => Array.isArray(taskTimeline?.[wtdView]) ? taskTimeline[wtdView] : [], [taskTimeline, wtdView]);

  const projectsChartData = useMemo(() => {
    const stats = data?.projectStats;

    if (!stats) return [];

    const { xaxis = [], Projects = [], yaxis = [] } = stats;

    const getSeries = (name) =>
      yaxis.find((y) => y.name === name)?.data || [];

    const completed = getSeries("Completed");
    const backlog = getSeries("Backlog");
    const inprogress = getSeries("In Progress");
    const approved = getSeries("Approved");

    return xaxis.map((code, idx) => ({
      projectCode: code,
      projectName: Projects[idx] || code,
      completed: completed[idx] || 0,
      pending: backlog[idx] || 0,
      inprogress: inprogress[idx] || 0,
      approved: approved[idx] || 0
    }));
  }, [data?.projectStats]);

  // ✅ FIXED: Handle chart click events with proper type detection
  const handleWTDChartClick = (state) => {
    if (!state || !state.activeTooltipIndex) return;

    const dataIndex = state.activeTooltipIndex;
    console.log(dataIndex, "--dataIndex");

    const chartData = wtdChartData[dataIndex];

    // Skip "Total" - it has a special key
    if (chartData?.key === 'total') return;

    // Valid task types: backlog, todo, completed, approved
    const validTypes = ['backlog', 'todo', 'completed', 'approved', 'transferto', 'blocked', 'rejected', 'totaltask'];
    if (chartData?.key && validTypes.includes(chartData.key)) {
      setDrillModal({ view: wtdView, type: chartData.key, filter: 'all' });
    }
  };

  // ✅ Wrap charts in memo to prevent re-renders from timer updates
  const WTDChart = useMemo(() => (
    <div style={{ width: "100%", height: 200 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={wtdChartData}
          onClick={handleWTDChartClick}
        >
          <XAxis dataKey="label"
            interval={0}                 // show all labels
            angle={-25}                 //  tilt labels
            textAnchor="end"          //  end align under bar
            tick={{ fontSize: 9, fill: "#94a3b8" }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 10, fill: "#94a3b8" }} axisLine={false} tickLine={false} />
          <Tooltip contentStyle={{ fontSize: 11, borderRadius: 8, border: "1px solid rgba(0,0,0,0.07)" }} />
          <Bar dataKey="val" radius={[6, 6, 0, 0]} barSize={28}>
            {wtdChartData.map((entry, i) => (
              <Cell key={`wtd-${wtdView}-${i}`} fill={entry.color || "#8884d8"} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  ), [wtdChartData, wtdView]);

  const ProjectsChart = useMemo(() => (


    <div style={{ height: 200 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={projectsChartData}
          margin={{ top: 10, right: 30, left: 0, bottom: 30 }}
        >
          <XAxis
            dataKey="projectCode"
            tick={{ fontSize: 12, fill: '#64748b', fontWeight: 500 }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 10, fill: '#94a3b8' }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            contentStyle={{ fontSize: 11, borderRadius: 8, border: '1px solid rgba(0,0,0,0.07)', backgroundColor: '#fff', color: '#1e293b' }}
            formatter={(value) => value.toLocaleString()}
            labelFormatter={(label, payload) => {
              if (payload && payload.length > 0) {
                return `${payload[0].payload.projectName}`;
              }
              return label;
            }}
          />
          <Bar dataKey="completed" fill={completedColor} name="Completed" radius={[4, 4, 0, 0]} barSize={12} />
          <Bar dataKey="pending" fill={backLogColor} name="Backlog" radius={[4, 4, 0, 0]} barSize={12} />
          <Bar dataKey="inprogress" fill={toDoColor} name="To Do" radius={[4, 4, 0, 0]} barSize={12} />
          <Bar dataKey="approved" fill={approvedColor} name="Approved" radius={[4, 4, 0, 0]} barSize={12} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  ), [projectsChartData]);

  if (dashboardDataV2Loading) return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={2}>
        {[1, 2, 3, 4].map(i => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Skeleton variant="rounded" height={120} />
          </Grid>
        ))}

        <Grid item xs={12} md={6}>
          <Skeleton variant="rounded" height={300} />
        </Grid>

        <Grid item xs={12} md={6}>
          <Skeleton variant="rounded" height={300} />
        </Grid>

        <Grid item xs={12} md={4}>
          <Skeleton variant="rounded" height={350} />
        </Grid>

        <Grid item xs={12} md={4}>
          <Skeleton variant="rounded" height={350} />
        </Grid>

        <Grid item xs={12} md={4}>
          <Skeleton variant="rounded" height={350} />
        </Grid>
      </Grid>

    </Box>
  );

  // const handleReadNotification =
  //   async (compID, empID,todayDate, RecordID) => {
  //     const response = await dispatch(EmergencyNotificationPost({ CompanyID: compID, EmployeeID: empID, RecordID: RecordID }));
  //     const res = response.payload; 
  //     if (res.Status === "Y") {
  //       toast.success(res.Msg || res.Message);
  //       setNotificationOpen(true);
  //       dispatch(EmergencyNotificationGet({ CompanyID: compID, EmployeeID: empID, EventDate:todayDate }));
  //     } else {
  //       toast.error(res.Msg || res.Message);
  //   };
  // }

  const handleReadNotification = async (
    compID,
    empID,
    todayDate,
    RecordID,
    IsRead
  ) => {
    const response = await dispatch(
      EmergencyNotificationPost({
        CompanyID: compID,
        EmployeeID: empID,
        RecordID,
        IsRead,
      })
    );

    const res = response.payload;

    if (res.Status === "Y") {
      toast.success(res.Msg || res.Message);

      dispatch(
        EmergencyNotificationGet({
          CompanyID: compID,
          EmployeeID: empID,
          EventDate: todayDate,
        })
      );

      setSelectedNotification(null);
    } else {
      toast.error(res.Msg || res.Message);
    }
  };

      const config = getConfig();
      const baseurl1 = config.BOS_URL;
      const baseurl = config.BASE_URL;
      console.log(baseurl1, "url path");



  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Outfit:wght@600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Plus Jakarta Sans', sans-serif; }
        @keyframes fadeUp { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)} }
        @keyframes modalIn { from{opacity:0;transform:translateY(20px) scale(0.97)} to{opacity:1;transform:translateY(0) scale(1)} }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }
        ::-webkit-scrollbar{width:4px} ::-webkit-scrollbar-thumb{background:#cbd5e1;border-radius:4px}
        input,textarea,select { font-family:'Plus Jakarta Sans',sans-serif; }
        input[type="date"]::-webkit-calendar-picker-indicator { opacity: 0.5; cursor: pointer; }
      `}</style>

      <Dialog
        open={notificationOpen}
        onClose={() => setNotificationOpen(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            maxHeight: "70vh",
            borderRadius: 2,
          }
        }}
      >
        <DialogTitle sx={{ borderBottom: "1px solid", borderColor: "divider", pb: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  width: 30,
                  height: 30,
                  bgcolor: "error.main",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 700,
                  fontSize: 17,
                  color: "#fff",
                  flexShrink: 0,
                }}
              >
                {emergencyData.NotificationCount || 0}
              </Box>
              <Box>
                <Typography variant="subtitle1" fontWeight={600} lineHeight={1.2}>
                  Emergency Notifications
                </Typography>
              </Box>
            </Box>
            <IconButton size="small" onClick={() => setNotificationOpen(false)}>
              <CloseOutlined fontSize="small" />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ p: 0 }}>
          <Box
            sx={{
              display: "flex",
              height: "60vh",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                // width: "50%",
                width: selectedNotification ? "60%" : "100%",
                borderRight: "1px solid",
                borderColor: "divider",
                overflowY: "auto",
              }}
            >
              {emergencyData?.Notifications?.length > 0 ? (
                <TableContainer>
                  <Table stickyHeader sx={{ overflow: "auto" }}>
                    <TableHead sx={{ fontWeight: "bold" }}>
                      <TableRow>
                        <TableCell sx={{
                          // width: "15px",
                          padding: "8px"
                        }}>SL#</TableCell>
                        <TableCell sx={{
                          //  width: "80px",
                          padding: "8px"
                        }}>Date</TableCell>
                        {/* <TableCell sx={{
                          // width: "100px",
                          padding: "8px"
                        }}>Title</TableCell> */}
                        <TableCell sx={{
                          //  width: 300, 
                          //  minWidth: 300, 
                          //  maxWidth: 300,
                          padding: "8px"
                        }}>
                          Message
                        </TableCell>
                        <TableCell sx={{
                          // width: "60px", 
                          padding: "8px"
                        }}>Status</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>

                      {emergencyData.Notifications?.map((n, index) => (
                        <TableRow
                          key={n.RecordID}
                          // sx={{ padding: "8px" }} 
                          // onClick={() => handleReadNotification(compID, empID, today, n.RecordID)}
                          onClick={() =>  {
                            setSelectedNotification(n);
                            setShowAudioPlayer(false); 
                            setAudioSrc("");

                          }}
                          sx={{
                            p: 2,
                            cursor: "pointer",
                            borderBottom: "1px solid",
                            borderColor: "divider",

                            bgcolor:
                              selectedNotification?.RecordID === n.RecordID
                                ? "action.selected"
                                : "transparent",

                            "&:hover": {
                              bgcolor: "action.hover",
                            },
                          }}
                        >
                          <TableCell sx={{
                            // width: "15px",
                            padding: "8px"
                          }}>{index + 1}</TableCell>
                          <TableCell sx={{
                            // width: "80px",
                            padding: "8px"
                          }}>{n.CreatedDate}</TableCell>
                          {/* <TableCell sx={{
                            // width: "100px", 
                            padding: "8px"
                          }}>{n.Title}</TableCell> */}
                          <TableCell sx={{
                            //  width: "300px",
                            padding: "8px"
                          }}>{n.Description}</TableCell>
                          <TableCell sx={{
                            // width: "50px", 
                            padding: "8px"
                          }}>
                            <Chip
                              label={n.IsRead === "N" ? "Unread" : "Read"}
                              color={n.IsRead === "N" ? "error" : "success"}
                              size="small"
                            // onClick={() => handleReadNotification(compID, empID,today, n.RecordID)}
                            />
                          </TableCell>
                        </TableRow>
                      ))}


                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: 5, gap: 2 }}>
                  <Typography variant="body2" sx={{ p: 3 }}>No notifications available.</Typography>
                </Box>
              )}
            </Box>
            {selectedNotification ?(
            <Box
              sx={{
                flex: 1,
                p: 3,
                overflowY: "auto",
              }}
            >
              {!selectedNotification ? (
                <Box
                  sx={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography color="text.secondary">
                    Select a notification to view details
                  </Typography>
                </Box>
              ) : (
                <>
                  <Typography variant="h6" fontWeight={600}>
                    {selectedNotification.Title}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 1 }}
                  >
                    {selectedNotification.CreatedDate}
                  </Typography>

                  <Chip
                    sx={{ mt: 2 }}
                    label={
                      selectedNotification.IsRead === "N"
                        ? "Unread"
                        : "Read"
                    }
                    color={
                      selectedNotification.IsRead === "N"
                        ? "error"
                        : "success"
                    }
                  />

                  <Typography
                    sx={{
                      mt: 3,
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {selectedNotification.Description}
                  </Typography>

                  <Box
                    sx={{
                      mt: 4,
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                    
                  >
                    
           {/* <Tooltip title="View Uploaded File"> */}
              {selectedNotification?.Attachment && (
          
                                          <IconButton
                                            color="primary"
                                            // disabled={!task.extendedProps?.Attachment}
                                            sx={{
                                              opacity: selectedNotification?.Attachment ? 1 : 0.4,
                                              cursor: selectedNotification?.Attachment
                                                ? "pointer"
                                                : "not-allowed",
                                            }}
                                            onClick={() => {
                                              if (selectedNotification?.Attachment) {
                                                window.open(
                                                 selectedNotification.NotificationType === "E" ?
                                                  `${baseurl1}uploads/images/${selectedNotification.Attachment}` 
                                                  :`${baseurl}uploads/images/${selectedNotification.Attachment}`
                                                 ,
                                                  "_blank",
                                                );
                                              }
                                            }}
                                          >
                                            <FileDownloadOutlinedIcon />
                                          </IconButton>
                                          
              )}
               {/* </Tooltip> */}
                                       
                                      
                                        {selectedNotification?.Video && (
                                            // <Tooltip title="View Uploaded Video">
  <IconButton
                                            color="primary"
                                            // disabled={!task.extendedProps?.Videos}
                                            sx={{
                                              opacity: selectedNotification?.Video
                                                ? 1
                                                : 0.4,
                                              cursor: selectedNotification?.Video
                                                ? "pointer"
                                                : "not-allowed",
                                            }}
                                            onClick={() => {
                                              if (selectedNotification?.Video) {
                                                window.open(
                                                  // store.getState().globalurl.videoattachmentUrl +
                                                  //   selectedNotification?.Video,
                                                
                                                 selectedNotification.NotificationType === "E" ?
                                                  `${baseurl1}uploads/videos/${selectedNotification.Video}` 
                                                  :`${baseurl}uploads/videos/${selectedNotification.Video}`
                                                 ,
                                               
                                                  "_blank",
                                                );
                                              }
                                            }}
                                          >
                                            <PlayCircleOutlinedIcon />
                                          </IconButton>
                                          // </Tooltip>
                                     )}
                                        
                                   
         
                  
                   
                    {selectedNotification?.Audio && (
//  <Tooltip title="View Uploaded Audio">
                                          // <IconButton
                                          //   color="primary"
                                          //   // disabled={!task.extendedProps?.Audio}
                                          //   sx={{
                                          //     opacity: selectedNotification?.Audio
                                          //       ? 1
                                          //       : 0.4,
                                          //     cursor: selectedNotification?.Audio
                                          //       ? "pointer"
                                          //       : "not-allowed",
                                          //   }}
                                          //   onClick={() => {
                                          //     if (selectedNotification?.Audio) {
                                          //       window.open(
                                          //         // store.getState().globalurl.audioattachmentUrl +
                                          //         //   selectedNotification.Audio,
                                          //            selectedNotification.NotificationType === "E" ?
                                          //         `${baseurl1}uploads/audios/${selectedNotification.Audio}` 
                                          //         :`${baseurl}uploads/audios/${selectedNotification.Audio}`
                                          //        ,
                                          //         "_blank",
                                          //       );
                                          //     }
                                          //   }}
                                          // >
                                          //   <SettingsVoiceIcon />
                                          // </IconButton>
                                           <IconButton
        color={showAudioPlayer ? "secondary" : "primary"}
        onClick={() => {
          const src =
            selectedNotification.NotificationType === "E"
              ? `${baseurl1}uploads/audios/${selectedNotification.Audio}`
              : `${baseurl}uploads/audios/${selectedNotification.Audio}`;
          setAudioSrc(src);
          setShowAudioPlayer((prev) => !prev);
        }}
      >
        <SettingsVoiceIcon />
      </IconButton>
                                                // </Tooltip>
                    )}

                                  
                    <Button
                      variant="contained"
                      color={
                        selectedNotification.IsRead === "N"
                          ? "success"
                          : "warning"
                      }
                      onClick={() =>
                        handleReadNotification(
                          compID,
                          empID,
                          today,
                          selectedNotification.RecordID,
                          selectedNotification.IsRead === "N"
                            ? "Y"
                            : "N"
                        )
                      }
                    >
                      {selectedNotification.IsRead === "N"
                        ? "Close Notification"
                        : "Reopen Notification"}
                    </Button>
                  </Box>
                          {/* Audio Player - shown below button when toggled */}
  {showAudioPlayer && audioSrc && (
    <Box
      sx={{
        mt: 2,
        width: "100%",
        borderRadius: 2,
        overflow: "hidden",
        bgcolor: "#f1f5f9",
        p: 1.5,
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: "block" }}>
        🎵 Audio Message
      </Typography>
      <audio
        controls
        autoPlay
        style={{ width: "100%", height: 40 }}
        src={audioSrc}
      >
        Your browser does not support the audio element.
      </audio>
    </Box>
  )}
                </>
              )}
            </Box>):(false)}
          </Box>
          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              px: 2,
              py: 1.5,
              borderTop: "1px solid",
              borderColor: "divider",
              gap: 2
            }}
          >  
            <Button
              variant="contained"
              color="error"
              onClick={() => setNotificationOpen(false)}
            >
              Close
            </Button>

          </Box> */}
        </DialogContent>
      </Dialog>

      <div style={{ display: 'flex', minHeight: '100vh', background: t.bg, fontFamily: "'Plus Jakarta Sans',sans-serif", fontSize: 13, color: '#1e293b' }}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          {/* Topbar */}
          <div style={{ background: '#fff', borderBottom: '1px solid rgba(0,0,0,0.07)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 28px', height: 58, position: 'sticky', top: 0, zIndex: 100 }}>
            <span style={{
              fontFamily: "'Outfit',sans-serif",
              // fontSize: 15, 
              // fontSize: 20,
              fontSize: "clamp(12px, 2vw, 20px)",
              fontWeight: 700,
              letterSpacing: 0.3
            }}>
              {/* {getDashboardTitle()} */}
              {getGreeting()}, {EmpName}
            </span>


            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div>
                {(is003Subscription && MultipleChildren === "Y") && (
                  <CheckinAutocompleteDash
                    sx={{
                      width: "200px"
                    }}
                    name="childs"
                    label={
                      <>
                        Child's
                        {/* <span style={{ color: "red", fontSize: "20px" }}>
                                                *
                                            </span> */}
                      </>
                    }
                    id="childs"
                    value={childName}
                    // value={values.childs}
                    onChange={async (newValue) => {
                      setChildName(newValue || null);

                      if (newValue) {
                        const data = await dispatch(
                          fetchApidata(newValue.Code, newValue.EmpDecryptPassWord, newValue.SubscriptionCode)
                        );

                        if (data.payload.Status === "Y") {
                          const { apiResponse, Recordid, EmpCount, ScrumMaster, CompanyAutoCode, Module, CompanyHeader, CompanyFooter, InvoiceFlag, CompanyGraceTime, CompanySessionTimeOut, CompanyLogo, ProjectManager, LoginType, MangerEmpID, ClassificationData, FirstLevelSub, MangerEmpDetails, SubscriptionCode, CompanySignature, Classification, CompanyQRCode } = data.payload;
                          // Update sessionStorage with the new child's data
                          console.log("Classification:", Classification);
                          sessionStorage.setItem("loginRecid", Recordid);
                          sessionStorage.setItem("UserName", apiResponse.Name);
                          sessionStorage.setItem("company", apiResponse.Company);
                          sessionStorage.setItem("companyId", apiResponse.EMP_CO);
                          sessionStorage.setItem("qualityassurance", apiResponse.EMP_QA);
                          sessionStorage.setItem("SubscriptionCode", SubscriptionCode);
                          sessionStorage.setItem("year", apiResponse.Year);
                          sessionStorage.setItem("YearFlag", apiResponse.YearFlag);
                          sessionStorage.setItem("stockflag", apiResponse.Process);
                          sessionStorage.setItem("Cifbysea", apiResponse.Cifbysea);
                          sessionStorage.setItem("Cifbyair", apiResponse.Cifbyair);
                          sessionStorage.setItem("Fob", apiResponse.Fob);
                          sessionStorage.setItem("Overhead", apiResponse.Overhead);
                          sessionStorage.setItem("YearRecorid", apiResponse.EMP_FINYEAR);
                          sessionStorage.setItem("Groupaccess", JSON.stringify(apiResponse.Groupaccess));
                          sessionStorage.setItem("Modules", JSON.stringify(apiResponse.Modules));
                          sessionStorage.setItem("EmpId", apiResponse.EMP_RECID);
                          sessionStorage.setItem("Locname", apiResponse.L_NAME);
                          sessionStorage.setItem("Locid", apiResponse.EMP_LRECID);
                          sessionStorage.setItem("Gateid", apiResponse.EMP_SGMRECID);
                          sessionStorage.setItem("Gatename", apiResponse.SGM_NAME);
                          sessionStorage.setItem("EmpName", apiResponse.EMP_NAME);
                          sessionStorage.setItem("isManager", EmpCount);
                          sessionStorage.setItem("isScrumaster", ScrumMaster);
                          sessionStorage.setItem("Classification", Classification);
                          sessionStorage.setItem("ClassificationRecID", apiResponse.EMP_CFCRECID);
                          sessionStorage.setItem("CompanyAutoCode", CompanyAutoCode);
                          sessionStorage.setItem("Module", Module);
                          sessionStorage.setItem("CompanyLogo", CompanyLogo || "");
                          sessionStorage.setItem("InvoiceFlag", InvoiceFlag || "");
                          sessionStorage.setItem("CompanyHeader", CompanyHeader || "");
                          sessionStorage.setItem("CompanyQRCode", CompanyQRCode || "");
                          sessionStorage.setItem("CompanyFooter", CompanyFooter || "");
                          sessionStorage.setItem("CompanySignature", CompanySignature || "");
                          sessionStorage.setItem("CompanyGraceTime", CompanyGraceTime || "");
                          sessionStorage.setItem("CompanySessionTimeOut", CompanySessionTimeOut || "");

                          sessionStorage.setItem("ParentID", ParentID);
                          sessionStorage.setItem("isprojectmanager", ProjectManager);
                          sessionStorage.setItem("MultipleChildren", MultipleChildren);
                          sessionStorage.setItem("MangerEmpID", JSON.stringify(MangerEmpID));
                          sessionStorage.setItem("ManagerEmpIDCS", MangerEmpID.join(","));
                          sessionStorage.setItem("EMP_TRAINBY", apiResponse.EMP_TRAINBY);
                          sessionStorage.setItem("FirstLevelSub", JSON.stringify(FirstLevelSub));
                          sessionStorage.setItem("MangerEmpDetails", JSON.stringify(MangerEmpDetails));
                          sessionStorage.setItem("ClassificationData", JSON.stringify(ClassificationData));
                          sessionStorage.setItem("currentPage", 0);
                          sessionStorage.setItem("secondaryCurrentPage", 0);
                          console.log(Module, "Modules");
                          // This bumps the key → forces child components to remount
                          setRefreshKey(prev => prev + 1);

                          if (LoginType === "1") {
                            navigate("/Changepassword");
                            return
                          }

                          if (apiResponse.EMP_QA == "Y" && EmpCount == 1) {
                            // navigate("/Apps/scrum-dashbord/P");
                            navigate("/Apps/scrum-dashbord/PM");
                            return
                          }
                          if (EmpCount == 1 && ScrumMaster != "Y" && ProjectManager != "Y") {
                            navigate("/Apps/manager-dashbord/M");
                            return
                          }
                          if (ProjectManager == "Y" && EmpCount == 1) {
                            // navigate("/Apps/scrum-dashbord/P");
                            navigate("/Apps/scrum-dashbord/PM");
                            return
                          }
                          if (ScrumMaster == "Y" && EmpCount == 1) {
                            navigate("/Apps/sprint-dashbord/S");
                            // navigate("/Apps/scrum-master-dashbord/S");
                            return
                          }

                          navigate("/Apps/dashbord/E");

                        }
                        else {
                          toast.error(
                            data?.payload?.Msg || "Invalid credentials"
                          );
                        }
                      }
                    }
                    }
                    url={`${listViewurl}?data={"Query":{"AccessID":"2181","ScreenName":"EMPLOYEETEAMS","Filter":"RecordID NOT IN('${empID}') AND CompanyID='${compID}' AND ParentID='${ParentID}'","Any":"","CompId":${compID}}}`}
                  />

                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 11, color: '#64748b', background: t.bg, padding: '5px 11px', borderRadius: 20, border: '1px solid rgba(0,0,0,0.07)' }}>
                <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
                {new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
              </div>

              {renderDashboardNavigation()}

              <button onClick={() => {
                setIsCalendar(!isCalendar)
                setIsEventCalendar(false);
              }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 32, height: 32, borderRadius: 10, border: '1px solid rgba(0,0,0,0.07)', background: isCalendar ? t.accent : t.bg, color: isCalendar ? '#fff' : t.accent, cursor: 'pointer', transition: 'all .18s' }} title={isCalendar ? "Show Dashboard" : "Show Calendar"} onMouseEnter={(e) => { e.currentTarget.style.background = isCalendar ? t.accent : '#f1f5f9'; }} onMouseLeave={(e) => { e.currentTarget.style.background = isCalendar ? t.accent : t.bg; }}>
                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /><path d="M9 14h6M9 18h6" /></svg>
              </button>
              {/* <button onClick={() => {setIsEventCalendar(!isEventCalendar)
                setIsCalendar(false);
              }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 32, height: 32, borderRadius: 10, border: '1px solid rgba(0,0,0,0.07)', background: isEventCalendar ? t.accent : t.bg, color: isEventCalendar ? '#fff' : t.accent, cursor: 'pointer', transition: 'all .18s' }} title={isEventCalendar ? "Show Dashboard" : "Show Event Calendar"} onMouseEnter={(e) => { e.currentTarget.style.background = isEventCalendar ? t.accent : '#f1f5f9'; }} onMouseLeave={(e) => { e.currentTarget.style.background = isEventCalendar ? t.accent : t.bg; }}>
                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /><path d="M9 14h6M9 18h6" /></svg>
              </button> */}

              {is003Subscription && (
                <>
                  <button
                    onClick={() => {
                      setIsEventCalendar(!isEventCalendar);
                      setIsCalendar(false);
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 32,
                      height: 32,
                      borderRadius: 10,
                      border: '1px solid rgba(0,0,0,0.07)',
                      background: isEventCalendar ? t.accent : t.bg,
                      color: isEventCalendar ? '#fff' : t.accent,
                      cursor: 'pointer',
                      transition: 'all .18s',
                    }}
                    title={isEventCalendar ? "Show Dashboard" : "Show Event Calendar"}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = isEventCalendar
                        ? t.accent
                        : '#f1f5f9';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = isEventCalendar
                        ? t.accent
                        : t.bg;
                    }}
                  >
                    <EventNoteOutlinedIcon style={{ fontSize: 18 }} />
                  </button>

                  {emergencyDataLoading ? <CircularProgress /> : (
                    <button
                      onClick={() => setNotificationOpen(true)}
                      style={{
                        position: "relative",

                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                        width: 32,
                        height: 32,

                        borderRadius: 10,
                        border: "1px solid rgba(0,0,0,0.07)",

                        background: t.bg,
                        cursor: "pointer",

                        padding: 0,
                      }}
                    >
                      <NotificationsActiveOutlinedIcon
                        style={{
                          fontSize: 18,
                          color: t.accent,
                        }}
                      />
                      <span
                        style={{
                          position: "absolute",

                          top: -4,
                          right: -4,

                          width: 14,
                          height: 14,

                          borderRadius: "50%",

                          background: "#ef4444",
                          color: "#fff",

                          fontSize: 9,
                          fontWeight: 700,

                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",

                          lineHeight: 1,
                        }}
                      >
                        {emergencyData.NotificationCount ? emergencyData.NotificationCount : "0"}
                      </span>
                    </button>
                  )}
                </>
              )}
              {/* <div ref={themeRef} style={{ position: 'relative' }}>
               
                {themeOpen && (
                  <div style={{ position: 'absolute', top: 'calc(100% + 8px)', right: 0, background: '#fff', borderRadius: 14, padding: 14, boxShadow: '0 8px 32px rgba(0,0,0,0.14)', border: '1px solid rgba(0,0,0,0.07)', width: 210, zIndex: 300, animation: 'fadeUp .18s ease' }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: '#94a3b8', letterSpacing: 0.6, marginBottom: 10 }}>Choose Theme</div>
                    {Object.entries({ default: ['#06b6d4', '#6366f1', '#0f172a'], ocean: ['#0ea5e9', '#6366f1', '#0c1a2e'], violet: ['#8b5cf6', '#ec4899', '#1a0f2e'], rose: ['#f43f5e', '#fb923c', '#2a0f16'], emerald: ['#10b981', '#06b6d4', '#0a1f16'], slate: ['#475569', '#64748b', '#1e293b'] }).map(([key, colors]) => (
                      <div key={key} onClick={() => { setTheme(key); setThemeOpen(false); }} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', borderRadius: 9, cursor: 'pointer', border: `1.5px solid ${theme === key ? t.accent : 'transparent'}`, background: theme === key ? '#f0fdff' : 'transparent', marginBottom: 4 }}
                        onMouseEnter={e => { if (theme !== key) e.currentTarget.style.background = '#f8fafc'; }}
                        onMouseLeave={e => { if (theme !== key) e.currentTarget.style.background = 'transparent'; }}
                      >
                        <div style={{ display: 'flex', gap: 4 }}>{colors.map((c, i) => <span key={i} style={{ width: 13, height: 13, borderRadius: '50%', background: c, display: 'inline-block' }}></span>)}</div>
                        <span style={{ fontSize: 12, fontWeight: 600, color: '#1e293b', textTransform: 'capitalize' }}>{key}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div> */}
              <div style={{ width: 32, height: 32, borderRadius: '50%', background: `linear-gradient(135deg, ${t.accent}, ${t.accent2})`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: '#fff', cursor: 'pointer', textAlign: 'center', overflow: 'hidden', whiteSpace: 'nowrap' }} title={EmpName}>
                {EmpName?.split(' ').slice(0, 2).map(word => word[0]?.toUpperCase()).join('')}
              </div>
            </div>
          </div>

          {/* Content */}
          <div style={{ padding: '20px 28px', flex: 1, overflowY: 'auto' }}>
            {isCalendar ? (
              <>
                {/* CALENDAR VIEW */}
                <div style={{ background: '#fff', borderRadius: 14, padding: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.05)' }}>
                  {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <h3 style={{ fontFamily: "'Outfit',sans-serif", fontSize: 14, fontWeight: 700 }}>Task Calendar</h3>
                  </div> */}
                  <div style={{ padding: '20px' }}>

                    {/* ✅ SAME ROW: Legend (left) + Employee (right) */}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between', // 🔥 pushes right content to end
                        marginBottom: 20,
                        paddingBottom: 15,
                        borderBottom: '1px solid rgba(0,0,0,0.07)'
                      }}
                    >
                      {/* ✅ LEFT SIDE - LEGENDS */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <div style={{ width: 14, height: 14, backgroundColor: '#b9ecee', borderRadius: '3px' }} />
                          <span style={{ fontSize: '13px', fontWeight: 500, color: '#1e293b' }}>Holiday</span>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <div style={{ width: 14, height: 14, backgroundColor: '#f3bac2', borderRadius: '3px' }} />
                          <span style={{ fontSize: '13px', fontWeight: 500, color: '#1e293b' }}>Week Off</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <div style={{ width: 14, height: 14, backgroundColor: '#ddcab1', borderRadius: '3px' }} />
                          <span style={{ fontSize: '13px', fontWeight: 500, color: '#1e293b' }}>Leave</span>
                        </div>
                      </div>

                      {/* ✅ RIGHT SIDE - EMPLOYEE DROPDOWN */}
                      {isManager === "1" && (
                        <div style={{ minWidth: 250 }}>
                          <Employeeautocomplete
                            name="empName"
                            label="Personnel"
                            id="empName"
                            value={selectedEmp}
                            onChange={(newValue) => {
                              if (newValue) {
                                setSelectedEmp(newValue);
                                const selectedEmpID = newValue.RecordID;

                                dispatch(
                                  DashcalpostData({
                                    Year: "2026",
                                    Month: "01,02,03,04,05,06,07,08,09,10,11,12",
                                    EmployeeID: selectedEmpID,
                                  })
                                );
                              } else {
                                setSelectedEmp(null);
                                dispatch(
                                  DashcalpostData({
                                    Year: "2026",
                                    Month: "01,02,03,04,05,06,07,08,09,10,11,12",
                                    EmployeeID: empID,
                                  })
                                );
                              }
                            }}
                            url={`${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${empID}","Any":"","CompId":${compID}}}`}
                          />
                        </div>
                      )}
                    </div>

                    {/* ✅ BELOW ROW */}
                    <Datavisual1 />

                  </div>
                </div>
              </>
            ) : isEventCalendar ? (
              <>
                {/* EVENT CALENDAR VIEW */}
                <div style={{ background: '#fff', borderRadius: 14, padding: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.05)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <h3 style={{ fontFamily: "'Outfit',sans-serif", fontSize: 14, fontWeight: 700 }}>Event Calendar</h3>
                  </div>
                  <div style={{ padding: '20px' }}>

                    {/* ✅ BELOW ROW */}
                    <EventCalender />

                  </div>
                </div>
              </>
            ) : (
              <>
                {/* Summary Cards */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 14, marginBottom: 20 }}>
                  {taskSummary.map((card, i) => {
                    const type = card.title.toLowerCase().includes("backlog") ? "backlog" : card.title.toLowerCase().includes("to do") ? "todo" : card.title.toLowerCase().includes("completed") ? "completed" : "totaltask";
                    const iconMap = {
                      backlog: <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3" /></svg>,
                      todo: <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" /></svg>,
                      completed: <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
                      totaltask: <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    };
                    // const handleCardClick = () => {
                    //   setDrillModal({ type, filter: "all", view: wtdView });
                    // };
                    const handleCardClick = () => {
                      setDrillModal({ type, filter: "all", view: wtdView, source: "tillDate" });
                    };
                    return (
                      <div key={card.title} onClick={handleCardClick} style={{ borderRadius: 14, padding: "18px 18px 14px", color: "#fff", cursor: "pointer", position: "relative", overflow: "hidden", transition: "transform .2s,box-shadow .2s", boxShadow: "0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.05)", background: card.gradient, animation: `fadeUp 0.45s ${i * 0.07}s both` }} onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 8px 32px rgba(0,0,0,0.12)"; }} onMouseLeave={(e) => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.05)"; }}>
                        <div style={{ position: "absolute", width: 90, height: 90, borderRadius: "50%", background: "rgba(255,255,255,0.1)", right: -18, top: -22 }} />
                        <div style={{ position: "absolute", width: 55, height: 55, borderRadius: "50%", background: "rgba(255,255,255,0.07)", right: 32, bottom: -18 }} />
                        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 5, position: "relative", zIndex: 1 }}>
                          <div style={{ fontSize: 12, fontWeight: 600, opacity: 0.82, letterSpacing: 0.7 }}>{card.title}</div>
                          <div style={{ width: 33, height: 33, borderRadius: "50%", background: "rgba(255,255,255,0.22)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>
                            {iconMap[type]}
                          </div>
                        </div>
                        <div style={{ fontFamily: "'Outfit',sans-serif", fontSize: 34, fontWeight: 800, lineHeight: 1, marginBottom: 10, position: "relative", zIndex: 1 }}>{card.count}</div>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 5, position: "relative", zIndex: 1 }}>
                          {card.breakdown?.map((tag) => (
                            <span key={tag} style={{ fontSize: 10, padding: "2px 7px", borderRadius: 20, background: "rgba(255,255,255,0.2)", fontWeight: 500 }}>{tag}</span>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Row 1: WTD + Projects */}
                <div style={{ display: 'grid', gridTemplateColumns: '1.3fr 1.8fr', gap: 14, marginBottom: 14 }}>
                  {/* WTD Chart */}
                  <div style={{ background: '#fff', borderRadius: 14, padding: '18px 20px', boxShadow: '0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.05)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                      <span style={{ fontFamily: "'Outfit',sans-serif", fontSize: 13, fontWeight: 700 }}>Week To Date</span>
                      <div style={{ display: 'flex', gap: 4 }}>
                        {['w2d', 'm2d'].map(v => (
                          <button key={v} onClick={() => setWtdView(v)} style={{ fontSize: 10, padding: '3px 10px', borderRadius: 7, border: '1px solid rgba(0,0,0,0.07)', background: wtdView === v ? t.accent : 'transparent', color: wtdView === v ? '#fff' : '#64748b', cursor: 'pointer', fontWeight: 600 }}>
                            {v.toUpperCase()}
                          </button>
                        ))}
                      </div>
                    </div>
                    {WTDChart}
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6.4, marginTop: 30 }}>
                      {[[backLogColor, 'Backlog'], [toDoColor, 'To Do'], [completedColor, 'Completed'], [approvedColor, 'Approved'], [transferredColor, 'Transfer to'], [blockedColor, 'Blocked'], [rejectedColor, 'Rejected'], [totalTaskColor, 'Total']].map(([c, l]) => (
                        <span key={l} style={{ display: 'flex', alignItems: 'center', gap: 3, fontSize: 10, color: '#64748b' }}>
                          <span style={{ width: 8, height: 8, borderRadius: 2, background: c }}></span>{l}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Projects Chart */}
                  <div style={{ background: '#fff', borderRadius: 14, padding: '18px 20px', boxShadow: '0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.05)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                      <span style={{ fontFamily: "'Outfit',sans-serif", fontSize: 13, fontWeight: 700 }}>Projects Task</span>
                    </div>

                    {ProjectsChart}

                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, marginTop: 12, paddingTop: 12, borderTop: '1px solid rgba(0,0,0,0.07)' }}>
                      {[
                        { color: completedColor, label: 'Completed' },
                        { color: backLogColor, label: 'Backlog' },
                        { color: toDoColor, label: 'To Do' },
                        { color: approvedColor, label: 'Approved' }
                      ].map(item => (
                        <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <span style={{ width: 12, height: 12, borderRadius: 3, background: item.color, flexShrink: 0 }}></span>
                          <span style={{ fontSize: 11, color: '#64748b', fontWeight: 500 }}>{item.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* TODAY & PERFORMANCE */}
                <div style={{ marginBottom: 14 }}>
                  <div style={{ background: 'linear-gradient(160deg,#0f172a 0%,#1e293b 100%)', borderRadius: 14, padding: '22px 28px', boxShadow: '0 8px 32px rgba(0,0,0,0.12)', color: '#fff', animation: 'fadeUp .45s .1s both' }}>
                    {/* Header */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
                      <span style={{ fontFamily: "'Outfit',sans-serif", fontSize: 12, fontWeight: 700, letterSpacing: 0.5, color: 'rgba(255,255,255,0.5)' }}>
                        Today & Performance
                      </span>
                      <span style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 10, fontWeight: 600, background: CheckInOutDetails?.CheckStatus === 'A' ? 'rgba(16,185,129,0.18)' : CheckInOutDetails?.CheckStatus === 'B' ? 'rgba(249,115,22,0.18)' : 'rgba(59,130,246,0.18)', color: CheckInOutDetails?.CheckStatus === 'A' ? '#34d399' : CheckInOutDetails?.CheckStatus === 'B' ? '#fb923c' : '#93c5fd', border: `1px solid ${CheckInOutDetails?.CheckStatus === 'A' ? 'rgba(16,185,129,0.3)' : CheckInOutDetails?.CheckStatus === 'B' ? 'rgba(249,115,22,0.3)' : 'rgba(59,130,246,0.3)'}`, borderRadius: 20, padding: '3px 10px' }}>
                        <span style={{ width: 6, height: 6, borderRadius: '50%', background: CheckInOutDetails?.CheckStatus === 'A' ? '#10b981' : CheckInOutDetails?.CheckStatus === 'B' ? '#f97316' : '#3b82f6', animation: CheckInOutDetails?.CheckStatus === 'A' ? 'pulse 1.5s infinite' : 'none' }}></span>
                        {CheckInOutDetails?.CheckStatus === 'A' ? '✓ Checked In' : CheckInOutDetails?.CheckStatus === 'B' ? '✓ Checked Out' : 'Not Checked In'}
                      </span>
                    </div>

                    {/* Main Content */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
                      {/* Time Display */}
                      <div style={{ minWidth: 180 }}>
                        <div style={{ fontFamily: "'Outfit',sans-serif", fontSize: 36, fontWeight: 800, letterSpacing: -1, lineHeight: 1, marginBottom: 3 }}>
                          {elapsedTime.display}
                        </div>
                        <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>
                          {CheckInOutDetails?.CheckInDate ? new Date(CheckInOutDetails.CheckInDate).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) : fmtDate(clock)}
                        </div>
                      </div>

                      <div style={{ width: 1, height: 64, background: 'rgba(255,255,255,0.1)', margin: '0 28px', flexShrink: 0 }} />

                      {/* Check In/Out Buttons */}
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, minWidth: 160 }}>
                        <button onClick={() => setModal('checkin')} disabled={CheckInOutDetails?.CheckStatus === 'A'} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7, padding: '10px 20px', borderRadius: 10, border: 'none', background: 'linear-gradient(135deg,#10b981,#059669)', color: '#fff', fontFamily: "'Plus Jakarta Sans',sans-serif", fontSize: 12, fontWeight: 700, cursor: CheckInOutDetails?.CheckStatus === 'A' ? 'not-allowed' : 'pointer', opacity: CheckInOutDetails?.CheckStatus === 'A' ? 0.5 : 1, transition: 'all .18s' }} title={CheckInOutDetails?.CheckStatus === 'A' ? 'Already checked in' : 'Click to check in'}>
                          <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" /><polyline points="10 17 15 12 10 7" /><line x1="15" y1="12" x2="3" y2="12" /></svg>
                          Check In
                        </button>

                        <button onClick={() => setModal('checkout')} disabled={CheckInOutDetails?.CheckStatus !== 'A'} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7, padding: '10px 20px', borderRadius: 10, border: 'none', background: 'linear-gradient(135deg,#f97316,#ea580c)', color: '#fff', fontFamily: "'Plus Jakarta Sans',sans-serif", fontSize: 12, fontWeight: 700, cursor: CheckInOutDetails?.CheckStatus === 'A' ? 'pointer' : 'not-allowed', opacity: CheckInOutDetails?.CheckStatus !== 'A' ? 0.5 : 1, transition: 'all .18s' }} title={CheckInOutDetails?.CheckStatus === 'A' ? 'Click to check out' : 'Check in first to check out'}>
                          <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></svg>
                          Check Out
                        </button>
                      </div>

                      <div style={{ width: 1, height: 64, background: 'rgba(255,255,255,0.1)', margin: '0 28px', flexShrink: 0 }} />

                      {/* Stats Grid */}
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', gap: 10, flex: 1 }}>
                        <div style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 9, padding: '10px 12px' }}>
                          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', fontWeight: 600, letterSpacing: 0.5, marginBottom: 4 }}>Check In</div>
                          <div style={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>{CheckInOutDetails?.CheckInTime || '—'}</div>
                        </div>
                        <div style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 9, padding: '10px 12px' }}>
                          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', fontWeight: 600, letterSpacing: 0.5, marginBottom: 4 }}>Check Out</div>
                          <div style={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>{CheckInOutDetails?.CheckOutTime || '—'}</div>
                        </div>
                        <div style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 9, padding: '10px 12px' }}>
                          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', fontWeight: 600, letterSpacing: 0.5, marginBottom: 4 }}>Hours Today</div>
                          <div style={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>{elapsedTime.display}</div>
                        </div>
                        <div style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 9, padding: '10px 12px' }}>
                          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', fontWeight: 600, letterSpacing: 0.5, marginBottom: 4 }}>This Week</div>
                          <div style={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>{CheckInOutDetails?.WeekWorkedFormatted || '0h 0m'}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Row 2: Leave + Aging + YTD */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 14 }}>
                  {/* Leave Details */}
                  <div style={{ background: '#fff', borderRadius: 14, padding: '18px 20px', boxShadow: '0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.05)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                      <span style={{ fontFamily: "'Outfit',sans-serif", fontSize: 13, fontWeight: 700 }}>Leave Details</span>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 10, color: '#64748b', background: t.bg, padding: '5px 11px', borderRadius: 20, border: '1px solid rgba(0,0,0,0.07)' }}>{currentYear}</div>
                    </div>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          {['Type', 'Total', 'Taken', 'Balance'].map((h, i) => (
                            <th key={h} style={{ fontSize: 11, letterSpacing: 0.8, color: '#94a3b8', fontWeight: 700, padding: '6px 10px', textAlign: i === 0 ? 'left' : 'right', borderBottom: '1px solid rgba(0,0,0,0.07)' }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {(leaveDetailsData?.tableData || []).map(({ label, toValue, taValue, rValue }) => (
                          <tr key={label}>
                            <td style={{ padding: '8px 10px', fontSize: 12, borderBottom: '1px solid rgba(0,0,0,0.07)', fontWeight: 500 }}>{label}</td>
                            <td style={{ padding: '8px 10px', fontSize: 12, borderBottom: '1px solid rgba(0,0,0,0.07)', textAlign: 'right' }}>{toValue}</td>
                            <td style={{ padding: '8px 10px', fontSize: 12, borderBottom: '1px solid rgba(0,0,0,0.07)', textAlign: 'right' }}>{taValue}</td>
                            <td style={{ padding: '8px 10px', fontSize: 12, borderBottom: '1px solid rgba(0,0,0,0.07)', textAlign: 'right', color: completedColor, fontWeight: 700 }}>{rValue}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <button onClick={() => {
                      setLeaveBalances(leaveDetailsData?.tableData || []);
                      setModal('applyleave')
                    }} style={{ display: 'block', width: '100%', marginTop: 14, padding: 10, background: '#1e293b', color: '#fff', border: 'none', borderRadius: 8, fontFamily: "'Plus Jakarta Sans',sans-serif", fontSize: 12, fontWeight: 600, cursor: 'pointer', letterSpacing: 0.3, transition: 'background .15s' }} onMouseEnter={e => e.currentTarget.style.background = '#334155'} onMouseLeave={e => e.currentTarget.style.background = '#1e293b'}>Apply New Leave</button>
                  </div>

                  {/* Aging */}
                  {/* <div style={{ background: '#fff', borderRadius: 14, padding: '18px 20px', boxShadow: '0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.05)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                      <span style={{ fontFamily: "'Outfit',sans-serif", fontSize: 13, fontWeight: 700 }}>Aging</span>
                      <div style={{ display: 'flex', gap: 4 }}>
                        {[['backlog', 'Backlog', backLogColor], ['todo', 'To do', toDoColor], ['completed', 'Completed', completedColor]].map(([key, label, color]) => (
                          <button key={key} onClick={() => setAgingView(key)} style={{ fontSize: 10, padding: '3px 10px', borderRadius: 7, border: `1px solid ${agingView === key ? color : 'rgba(0,0,0,0.07)'}`, background: agingView === key ? color : 'transparent', color: agingView === key ? '#fff' : '#64748b', cursor: 'pointer', fontWeight: 600 }}>
                            {label}
                          </button>
                        ))}
                      </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
                      <DonutChart data={agingData.data} colors={agingData.colors} size={140} cutout={75} centerText={agPct} centerSub={agingData.labels[0]} />
                      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 12 }}>
                        {agingData.labels.map((label, i) => {
                          const pct = agTotal === 0 ? 0 : Math.round((agingData.data[i] / agTotal) * 100);
                          return (
                            <div key={label}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                                <span style={{ fontSize: 11, color: '#64748b' }}>{label}</span>
                                <span style={{ fontSize: 12, fontWeight: 700, color: agingData.colors[i] }}>{pct}%</span>
                              </div>
                              <div style={{ background: '#f1f5f9', borderRadius: 4, height: 6, overflow: 'hidden' }}>
                                <div style={{ width: `${pct}%`, background: agingData.colors[i], height: '100%', borderRadius: 4 }} />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div> */}

                  {/* Aging */}
                  <div style={{ background: '#fff', borderRadius: 14, padding: '18px 20px', boxShadow: '0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.05)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                      <span style={{ fontFamily: "'Outfit',sans-serif", fontSize: 13, fontWeight: 700 }}>Aging</span>
                      <div style={{ display: 'flex', gap: 4 }}>
                        {[['backlog', 'Backlog', backLogColor], ['todo', 'To do', toDoColor], ['completed', 'Completed', completedColor]].map(([key, label, color]) => (
                          <button
                            key={key}
                            onClick={() => {
                              setAgingView(key);
                              setAgingLabel(label);
                              setAgingColor(color);
                            }}
                            style={{
                              fontSize: 10,
                              padding: '3px 10px',
                              borderRadius: 7,
                              border: `1px solid ${agingView === key ? color : 'rgba(0,0,0,0.07)'}`,
                              background: agingView === key ? color : 'transparent',
                              color: agingView === key ? '#fff' : '#64748b',
                              cursor: 'pointer',
                              fontWeight: 600
                            }}>
                            {label}
                          </button>
                        ))}
                      </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                      {/* Summary metric instead of donut */}
                      <div style={{ display: 'flex', gap: 16 }}>
                        <div style={{
                          flex: 1,
                          background: agingColor ? `${agingColor}15` : `${completedColor}15`,  // Light background with color tint
                          borderRadius: 10,
                          padding: '12px 14px',
                          textAlign: 'center',
                          border: `2px solid ${agingColor || completedColor}`,  // Colored border
                          transition: 'all 0.3s ease'  // Smooth transition
                        }}>
                          <div style={{ fontSize: 24, fontWeight: 700, color: agingColor ?? completedColor }}>
                            {agTotal}
                          </div>
                          <div style={{ fontSize: 11, color: '#64748b', marginTop: 4 }}>
                            Total {agingLabel.charAt(0).toUpperCase() + agingLabel.slice(1)} Tasks
                          </div>
                        </div>
                        {/* <div style={{
                          flex: 1,
                          background: agingData.colors[2] ? `${agingData.colors[2]}15` : '#f8fafc',
                          borderRadius: 10,
                          padding: '12px 14px',
                          textAlign: 'center',
                          border: `2px solid ${agingData.colors[2] || '#e2e8f0'}`,
                          transition: 'all 0.3s ease'
                        }}>
                          <div style={{ fontSize: 24, fontWeight: 700, color: agingData.colors[2] }}>
                            {agingData.data[2]}
                          </div>
                        </div> */}
                      </div>

                      {/* Age breakdown bars */}
                      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 12 }}>
                        {agingData.labels.map((label, i) => {
                          const pct = agTotal === 0 ? 0 : Math.round((agingData.data[i] / agTotal) * 100);
                          return (
                            <div key={label}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                <div>
                                  <span style={{ fontSize: 11, color: '#64748b', fontWeight: 500 }}>{label}</span>
                                  <span style={{ fontSize: 12, fontWeight: 700, color: agingData.colors[i], marginLeft: 8 }}>
                                    {agingData.data[i]} tasks
                                  </span>
                                </div>
                                <span style={{ fontSize: 12, fontWeight: 600, color: '#64748b' }}>{pct}%</span>
                              </div>
                              <div style={{ background: '#f1f5f9', borderRadius: 4, height: 6, overflow: 'hidden' }}>
                                <div style={{ width: `${pct}%`, background: agingData.colors[i], height: '100%', borderRadius: 4 }} />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>

                  {/* YTD Attendance */}
                  <div style={{ background: '#fff', borderRadius: 14, padding: '18px 20px', boxShadow: '0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.05)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                      <span style={{ fontFamily: "'Outfit',sans-serif", fontSize: 13, fontWeight: 700 }}>YTD Attendance</span>
                      <div style={{ display: 'flex', gap: 4 }}>
                        {['M2D', 'Y2D'].map(v => (
                          <button key={v} onClick={() => setYtdView(v)} style={{ fontSize: 10, padding: '3px 10px', borderRadius: 7, border: '1px solid rgba(0,0,0,0.07)', background: ytdView === v ? t.accent : 'transparent', color: ytdView === v ? '#fff' : '#64748b', cursor: 'pointer', fontWeight: 600 }}>
                            {v.toUpperCase()}
                          </button>
                        ))}
                      </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
                      <DonutChart data={ytdData.data} colors={ytdData.colors} size={130} cutout={80} centerText={ytdPct} centerSub="Present" />
                      {attendance?.[ytdView] && (
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 8 }}>
                          {attendance[ytdView].labels.map((label, i) => {
                            const maxVal = Math.max(...attendance[ytdView].data) || 1;
                            const pct = Math.round((attendance[ytdView].data[i] / maxVal) * 100);
                            return (
                              <div key={label} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <div style={{ width: 9, height: 9, borderRadius: '50%', background: attendance[ytdView].colors[i] }} />
                                <span style={{ fontSize: 11, color: '#64748b', minWidth: 80 }}>{label}</span>
                                <span style={{ fontSize: 12, fontWeight: 700, minWidth: 30 }}>{attendance[ytdView].data[i]}</span>
                                <div style={{ flex: 1, background: '#f1f5f9', borderRadius: 4, height: 6, overflow: 'hidden' }}>
                                  <div style={{ width: `${pct}%`, background: attendance[ytdView].colors[i], height: '100%', borderRadius: 4 }} />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* DRILL-DOWN MODAL */}
      {drillModal && <DrillDownModal drill={drillModal} tasks={drillTasks} onClose={() => setDrillModal(null)} t={t} colors={overallColors} />}

      {/* Modals */}
      {modal === 'checkin' && <CheckInModal onClose={() => setModal(null)} onSave={onCheckIn} theme={t} />}
      {modal === 'checkout' && <CheckOutModal onClose={() => setModal(null)} onSave={onCheckOut} checkedInID={CheckInOutDetails?.AttendanceID} />}
      {modal === 'applyleave' && <ApplyLeaveModal
        key={JSON.stringify(leaveBalances)}
        onClose={() => setModal(null)}
        onSave={onLeave}
        colors={overallColors}
        balances={leaveBalances} />}

      {/* Toast */}
      <Toast toasts={toasts} />
    </>
  );
}
